// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,400&family=Hanken+Grotesk:ital,wght@0,400;0,500;0,600;0,700;1,500&family=Inter:wght@400;500;600&family=Plus+Jakarta+Sans:wght@600;700;800&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: "DM Sans", system-ui, sans-serif;
    --font-serif: ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
    --font-mono: Consolas, "Courier New", monospace;
    --color-red-50: oklch(97.1% 0.013 17.38);
    --color-red-100: oklch(93.6% 0.032 17.717);
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-400: oklch(70.4% 0.191 22.216);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-red-800: oklch(44.4% 0.177 26.899);
    --color-orange-100: oklch(95.4% 0.038 75.164);
    --color-amber-50: oklch(98.7% 0.022 95.277);
    --color-amber-200: oklch(92.4% 0.12 95.746);
    --color-amber-700: oklch(55.5% 0.163 48.998);
    --color-amber-800: oklch(47.3% 0.137 46.201);
    --color-amber-900: oklch(41.4% 0.112 45.904);
    --color-green-50: oklch(98.2% 0.018 155.826);
    --color-green-100: oklch(96.2% 0.044 156.743);
    --color-green-200: oklch(92.5% 0.084 155.995);
    --color-green-300: oklch(87.1% 0.15 154.449);
    --color-green-400: oklch(79.2% 0.209 151.711);
    --color-green-500: oklch(72.3% 0.219 149.579);
    --color-green-600: oklch(62.7% 0.194 149.214);
    --color-green-700: oklch(52.7% 0.154 150.069);
    --color-green-800: oklch(44.8% 0.119 151.328);
    --color-blue-200: oklch(88.2% 0.059 254.128);
    --color-blue-300: oklch(80.9% 0.105 251.813);
    --color-blue-400: oklch(70.7% 0.165 254.624);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-indigo-100: oklch(93% 0.034 272.788);
    --color-indigo-200: oklch(87% 0.065 274.039);
    --color-indigo-400: oklch(67.3% 0.182 276.935);
    --color-violet-100: oklch(94.3% 0.029 294.588);
    --color-violet-700: oklch(49.1% 0.27 292.581);
    --color-purple-200: oklch(90.2% 0.063 306.703);
    --color-rose-700: oklch(51.4% 0.222 16.935);
    --color-rose-800: oklch(45.5% 0.188 13.697);
    --color-slate-50: oklch(98.4% 0.003 247.858);
    --color-slate-100: oklch(96.8% 0.007 247.896);
    --color-slate-200: oklch(92.9% 0.013 255.508);
    --color-slate-300: oklch(86.9% 0.022 252.894);
    --color-slate-400: oklch(70.4% 0.04 256.788);
    --color-slate-500: oklch(55.4% 0.046 257.417);
    --color-slate-600: oklch(44.6% 0.043 257.281);
    --color-slate-700: oklch(37.2% 0.044 257.287);
    --color-slate-800: oklch(27.9% 0.041 260.031);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-xs: 20rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --container-4xl: 56rem;
    --container-5xl: 64rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --font-weight-light: 300;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --font-weight-extrabold: 800;
    --font-weight-black: 900;
    --tracking-tight: -0.025em;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --tracking-widest: 0.1em;
    --leading-tight: 1.25;
    --leading-snug: 1.375;
    --leading-normal: 1.5;
    --leading-relaxed: 1.625;
    --radius-sm: 0.25rem;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --radius-3xl: 1.5rem;
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --animate-bounce: bounce 1s infinite;
    --blur-sm: 8px;
    --blur-2xl: 40px;
    --blur-3xl: 64px;
    --aspect-video: 16 / 9;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --color-sidebar: #eff7ff;
    --color-page-bg: #f8fafc;
    --color-primary: #f19500;
    --color-primary-hover: #875300;
    --color-primary-active: #482c00;
    --color-primary-disabled: #fff9ee;
    --color-primary-soft: #fff9ee;
    --color-secondary: #009dff;
    --color-secondary-soft: #eff7ff;
    --color-text-primary: #1d1b20;
    --color-text-secondary: #494551;
    --color-preview: #4f378a;
    --color-preview-bg: rgba(79, 55, 138, 0.1);
    --spacing-0: 0;
    --spacing-1: 0.25rem;
    --spacing-2: 0.5rem;
    --spacing-3: 0.75rem;
    --spacing-4: 1rem;
    --spacing-5: 1.25rem;
    --spacing-6: 1.5rem;
    --spacing-7: 1.75rem;
    --spacing-8: 2rem;
    --spacing-10: 2.5rem;
    --spacing-12: 3rem;
    --spacing-stack-sm: 0.5rem;
    --spacing-inline: 0.75rem;
    --spacing-card-sm: 1rem;
    --spacing-page-x: 1rem;
    --spacing-page-y: 1.5rem;
    --spacing-section: 1.5rem;
    --spacing-card: 1.5rem;
    --spacing-toolbar-x: 1rem;
    --spacing-page-x-lg: 2rem;
    --spacing-page-y-lg: 2rem;
    --spacing-section-lg: 2rem;
    --spacing-toolbar-x-lg: 1.5rem;
    --spacing-dashboard-stack: 2.5rem;
    --spacing-action-bar: 6rem;
    --spacing-action-bar-lg: 7rem;
    --spacing-btn-x: 1.5rem;
    --spacing-btn-y: 0.75rem;
    --spacing-content-max: 67.3125rem;
    --spacing-dashboard-max: 68.75rem;
    --font-inter: "Inter", system-ui, sans-serif;
    --font-jakarta: "Plus Jakarta Sans", "DM Sans", system-ui, sans-serif;
    --font-hanken: "Hanken Grotesk", "DM Sans", system-ui, sans-serif;
    --duration-workspace-enter: 220ms;
    --duration-workspace-overlay-enter: 180ms;
    --duration-workspace-overlay-exit: 160ms;
    --ease-workspace: cubic-bezier(0.22, 1, 0.36, 1);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .pointer-events-auto {
    pointer-events: auto;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .collapse {
    visibility: collapse;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: var(--spacing-0);
  }
  .inset-2 {
    inset: var(--spacing-2);
  }
  .inset-2\\.5 {
    inset: calc(var(--spacing) * 2.5);
  }
  .inset-3 {
    inset: var(--spacing-3);
  }
  .inset-\\[-3\\.75\\%_-4\\.69\\%\\] {
    inset: -3.75% -4.69%;
  }
  .inset-\\[-4\\.8\\%_-1\\.81\\%_0_0\\] {
    inset: -4.8% -1.81% 0 0;
  }
  .inset-\\[8\\.33\\%_16\\.67\\%\\] {
    inset: 8.33% 16.67%;
  }
  .inset-\\[12\\.5\\%_13\\.46\\%_9\\.38\\%_9\\.33\\%\\] {
    inset: 12.5% 13.46% 9.38% 9.33%;
  }
  .inset-x-4 {
    inset-inline: var(--spacing-4);
  }
  .inset-y-0 {
    inset-block: var(--spacing-0);
  }
  .-top-0\\.5 {
    top: calc(var(--spacing) * -0.5);
  }
  .-top-1\\.5 {
    top: calc(var(--spacing) * -1.5);
  }
  .-top-2 {
    top: calc(var(--spacing-2) * -1);
  }
  .-top-8 {
    top: calc(var(--spacing-8) * -1);
  }
  .-top-10 {
    top: calc(var(--spacing-10) * -1);
  }
  .-top-12 {
    top: calc(var(--spacing-12) * -1);
  }
  .-top-24 {
    top: calc(var(--spacing) * -24);
  }
  .top-0 {
    top: var(--spacing-0);
  }
  .top-0\\.5 {
    top: calc(var(--spacing) * 0.5);
  }
  .top-1 {
    top: var(--spacing-1);
  }
  .top-1\\.5 {
    top: calc(var(--spacing) * 1.5);
  }
  .top-1\\/2 {
    top: calc(1 / 2 * 100%);
  }
  .top-1\\/3 {
    top: calc(1 / 3 * 100%);
  }
  .top-2 {
    top: var(--spacing-2);
  }
  .top-3 {
    top: var(--spacing-3);
  }
  .top-4 {
    top: var(--spacing-4);
  }
  .top-5 {
    top: var(--spacing-5);
  }
  .top-\\[-4px\\] {
    top: -4px;
  }
  .top-\\[-15\\.93\\%\\] {
    top: -15.93%;
  }
  .top-\\[-15px\\] {
    top: -15px;
  }
  .top-\\[-25px\\] {
    top: -25px;
  }
  .top-\\[2px\\] {
    top: 2px;
  }
  .top-\\[4px\\] {
    top: 4px;
  }
  .top-\\[9px\\] {
    top: 9px;
  }
  .top-\\[10px\\] {
    top: 10px;
  }
  .top-\\[11\\.5px\\] {
    top: 11.5px;
  }
  .top-\\[14px\\] {
    top: 14px;
  }
  .top-\\[16px\\] {
    top: 16px;
  }
  .top-\\[17px\\] {
    top: 17px;
  }
  .top-\\[24px\\] {
    top: 24px;
  }
  .top-\\[52\\.45px\\] {
    top: 52.45px;
  }
  .top-\\[52px\\] {
    top: 52px;
  }
  .top-\\[56\\.5px\\] {
    top: 56.5px;
  }
  .top-\\[59px\\] {
    top: 59px;
  }
  .top-\\[64px\\] {
    top: 64px;
  }
  .top-\\[75px\\] {
    top: 75px;
  }
  .top-\\[85\\.99px\\] {
    top: 85.99px;
  }
  .top-\\[427px\\] {
    top: 427px;
  }
  .top-\\[428px\\] {
    top: 428px;
  }
  .top-\\[560px\\] {
    top: 560px;
  }
  .top-\\[619px\\] {
    top: 619px;
  }
  .top-\\[calc\\(50\\%\\+0\\.5px\\)\\] {
    top: calc(50% + 0.5px);
  }
  .top-\\[calc\\(50\\%\\+24\\.5px\\)\\] {
    top: calc(50% + 24.5px);
  }
  .top-\\[calc\\(50\\%\\+28\\.17px\\)\\] {
    top: calc(50% + 28.17px);
  }
  .top-\\[calc\\(100\\%\\+0\\.5rem\\)\\] {
    top: calc(100% + 0.5rem);
  }
  .top-full {
    top: 100%;
  }
  .-right-0\\.5 {
    right: calc(var(--spacing) * -0.5);
  }
  .-right-1\\.5 {
    right: calc(var(--spacing) * -1.5);
  }
  .-right-2 {
    right: calc(var(--spacing-2) * -1);
  }
  .-right-8 {
    right: calc(var(--spacing-8) * -1);
  }
  .-right-10 {
    right: calc(var(--spacing-10) * -1);
  }
  .-right-12 {
    right: calc(var(--spacing-12) * -1);
  }
  .-right-24 {
    right: calc(var(--spacing) * -24);
  }
  .right-0 {
    right: var(--spacing-0);
  }
  .right-1 {
    right: var(--spacing-1);
  }
  .right-1\\.5 {
    right: calc(var(--spacing) * 1.5);
  }
  .right-1\\/4 {
    right: calc(1 / 4 * 100%);
  }
  .right-2 {
    right: var(--spacing-2);
  }
  .right-3 {
    right: var(--spacing-3);
  }
  .right-4 {
    right: var(--spacing-4);
  }
  .right-5 {
    right: var(--spacing-5);
  }
  .right-8 {
    right: var(--spacing-8);
  }
  .right-\\[-40px\\] {
    right: -40px;
  }
  .right-\\[8\\.79px\\] {
    right: 8.79px;
  }
  .right-\\[16\\%\\] {
    right: 16%;
  }
  .right-\\[36px\\] {
    right: 36px;
  }
  .right-\\[63px\\] {
    right: 63px;
  }
  .-bottom-2 {
    bottom: calc(var(--spacing-2) * -1);
  }
  .-bottom-8 {
    bottom: calc(var(--spacing-8) * -1);
  }
  .-bottom-10 {
    bottom: calc(var(--spacing-10) * -1);
  }
  .-bottom-12 {
    bottom: calc(var(--spacing-12) * -1);
  }
  .-bottom-16 {
    bottom: calc(var(--spacing) * -16);
  }
  .-bottom-40 {
    bottom: calc(var(--spacing) * -40);
  }
  .bottom-0 {
    bottom: var(--spacing-0);
  }
  .bottom-3 {
    bottom: var(--spacing-3);
  }
  .bottom-4 {
    bottom: var(--spacing-4);
  }
  .bottom-\\[-40px\\] {
    bottom: -40px;
  }
  .bottom-\\[calc\\(100\\%\\+6px\\)\\] {
    bottom: calc(100% + 6px);
  }
  .bottom-\\[calc\\(100\\%\\+10px\\)\\] {
    bottom: calc(100% + 10px);
  }
  .bottom-full {
    bottom: 100%;
  }
  .-left-8 {
    left: calc(var(--spacing-8) * -1);
  }
  .-left-10 {
    left: calc(var(--spacing-10) * -1);
  }
  .-left-16 {
    left: calc(var(--spacing) * -16);
  }
  .-left-40 {
    left: calc(var(--spacing) * -40);
  }
  .left-0 {
    left: var(--spacing-0);
  }
  .left-0\\.5 {
    left: calc(var(--spacing) * 0.5);
  }
  .left-1\\/2 {
    left: calc(1 / 2 * 100%);
  }
  .left-1\\/3 {
    left: calc(1 / 3 * 100%);
  }
  .left-3 {
    left: var(--spacing-3);
  }
  .left-3\\.5 {
    left: calc(var(--spacing) * 3.5);
  }
  .left-4 {
    left: var(--spacing-4);
  }
  .left-5 {
    left: var(--spacing-5);
  }
  .left-6 {
    left: var(--spacing-6);
  }
  .left-8 {
    left: var(--spacing-8);
  }
  .left-\\[-1px\\] {
    left: -1px;
  }
  .left-\\[-148\\.48\\%\\] {
    left: -148.48%;
  }
  .left-\\[10px\\] {
    left: 10px;
  }
  .left-\\[12px\\] {
    left: 12px;
  }
  .left-\\[13\\.5px\\] {
    left: 13.5px;
  }
  .left-\\[14px\\] {
    left: 14px;
  }
  .left-\\[18\\%\\] {
    left: 18%;
  }
  .left-\\[20px\\] {
    left: 20px;
  }
  .left-\\[24px\\] {
    left: 24px;
  }
  .left-\\[26px\\] {
    left: 26px;
  }
  .left-\\[29px\\] {
    left: 29px;
  }
  .left-\\[44px\\] {
    left: 44px;
  }
  .left-\\[48px\\] {
    left: 48px;
  }
  .left-\\[88px\\] {
    left: 88px;
  }
  .left-\\[118\\.22px\\] {
    left: 118.22px;
  }
  .left-\\[179px\\] {
    left: 179px;
  }
  .left-\\[213px\\] {
    left: 213px;
  }
  .left-\\[264px\\] {
    left: 264px;
  }
  .left-\\[282\\.8px\\] {
    left: 282.8px;
  }
  .left-\\[305px\\] {
    left: 305px;
  }
  .left-\\[357\\.84px\\] {
    left: 357.84px;
  }
  .left-\\[553px\\] {
    left: 553px;
  }
  .left-\\[589px\\] {
    left: 589px;
  }
  .left-\\[646px\\] {
    left: 646px;
  }
  .left-\\[968px\\] {
    left: 968px;
  }
  .left-\\[1052px\\] {
    left: 1052px;
  }
  .left-px {
    left: 1px;
  }
  .z-10 {
    z-index: 10;
  }
  .z-20 {
    z-index: 20;
  }
  .z-30 {
    z-index: 30;
  }
  .z-40 {
    z-index: 40;
  }
  .z-50 {
    z-index: 50;
  }
  .z-\\[1\\] {
    z-index: 1;
  }
  .z-\\[80\\] {
    z-index: 80;
  }
  .z-\\[90\\] {
    z-index: 90;
  }
  .z-\\[95\\] {
    z-index: 95;
  }
  .z-\\[100\\] {
    z-index: 100;
  }
  .z-\\[120\\] {
    z-index: 120;
  }
  .col-1 {
    grid-column: 1;
  }
  .col-span-1 {
    grid-column: span 1 / span 1;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-span-4 {
    grid-column: span 4 / span 4;
  }
  .col-start-1 {
    grid-column-start: 1;
  }
  .row-1 {
    grid-row: 1;
  }
  .row-start-1 {
    grid-row-start: 1;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .m-auto {
    margin: auto;
  }
  .mx-0\\.5 {
    margin-inline: calc(var(--spacing) * 0.5);
  }
  .mx-1 {
    margin-inline: var(--spacing-1);
  }
  .mx-2 {
    margin-inline: var(--spacing-2);
  }
  .mx-6 {
    margin-inline: var(--spacing-6);
  }
  .mx-10 {
    margin-inline: var(--spacing-10);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-1 {
    margin-block: var(--spacing-1);
  }
  .my-4 {
    margin-block: var(--spacing-4);
  }
  .my-5 {
    margin-block: var(--spacing-5);
  }
  .my-6 {
    margin-block: var(--spacing-6);
  }
  .my-8 {
    margin-block: var(--spacing-8);
  }
  .-mt-0 {
    margin-top: calc(var(--spacing-0) * -1);
  }
  .-mt-3 {
    margin-top: calc(var(--spacing-3) * -1);
  }
  .mt-0 {
    margin-top: var(--spacing-0);
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: var(--spacing-1);
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .mt-2 {
    margin-top: var(--spacing-2);
  }
  .mt-2\\.5 {
    margin-top: calc(var(--spacing) * 2.5);
  }
  .mt-3 {
    margin-top: var(--spacing-3);
  }
  .mt-3\\.5 {
    margin-top: calc(var(--spacing) * 3.5);
  }
  .mt-4 {
    margin-top: var(--spacing-4);
  }
  .mt-5 {
    margin-top: var(--spacing-5);
  }
  .mt-6 {
    margin-top: var(--spacing-6);
  }
  .mt-7 {
    margin-top: var(--spacing-7);
  }
  .mt-8 {
    margin-top: var(--spacing-8);
  }
  .mt-10 {
    margin-top: var(--spacing-10);
  }
  .mt-\\[0\\.45rem\\] {
    margin-top: 0.45rem;
  }
  .mt-\\[5px\\] {
    margin-top: 5px;
  }
  .mt-\\[19\\.71px\\] {
    margin-top: 19.71px;
  }
  .mt-\\[22px\\] {
    margin-top: 22px;
  }
  .mt-\\[61\\.09px\\] {
    margin-top: 61.09px;
  }
  .mt-\\[87\\.55px\\] {
    margin-top: 87.55px;
  }
  .mt-auto {
    margin-top: auto;
  }
  .mt-card-sm {
    margin-top: var(--spacing-card-sm);
  }
  .mt-px {
    margin-top: 1px;
  }
  .mt-stack-sm {
    margin-top: var(--spacing-stack-sm);
  }
  .mr-1 {
    margin-right: var(--spacing-1);
  }
  .mr-2 {
    margin-right: var(--spacing-2);
  }
  .-mb-px {
    margin-bottom: -1px;
  }
  .mb-0 {
    margin-bottom: var(--spacing-0);
  }
  .mb-0\\.5 {
    margin-bottom: calc(var(--spacing) * 0.5);
  }
  .mb-1 {
    margin-bottom: var(--spacing-1);
  }
  .mb-1\\.5 {
    margin-bottom: calc(var(--spacing) * 1.5);
  }
  .mb-2 {
    margin-bottom: var(--spacing-2);
  }
  .mb-2\\.5 {
    margin-bottom: calc(var(--spacing) * 2.5);
  }
  .mb-3 {
    margin-bottom: var(--spacing-3);
  }
  .mb-4 {
    margin-bottom: var(--spacing-4);
  }
  .mb-5 {
    margin-bottom: var(--spacing-5);
  }
  .mb-6 {
    margin-bottom: var(--spacing-6);
  }
  .mb-8 {
    margin-bottom: var(--spacing-8);
  }
  .mb-10 {
    margin-bottom: var(--spacing-10);
  }
  .-ml-1 {
    margin-left: calc(var(--spacing-1) * -1);
  }
  .ml-0 {
    margin-left: var(--spacing-0);
  }
  .ml-0\\.5 {
    margin-left: calc(var(--spacing) * 0.5);
  }
  .ml-1 {
    margin-left: var(--spacing-1);
  }
  .ml-1\\.5 {
    margin-left: calc(var(--spacing) * 1.5);
  }
  .ml-2 {
    margin-left: var(--spacing-2);
  }
  .ml-3 {
    margin-left: var(--spacing-3);
  }
  .ml-4 {
    margin-left: var(--spacing-4);
  }
  .ml-9 {
    margin-left: calc(var(--spacing) * 9);
  }
  .ml-\\[21px\\] {
    margin-left: 21px;
  }
  .ml-\\[68\\.29px\\] {
    margin-left: 68.29px;
  }
  .ml-\\[70\\.38px\\] {
    margin-left: 70.38px;
  }
  .ml-\\[259\\.39px\\] {
    margin-left: 259.39px;
  }
  .ml-auto {
    margin-left: auto;
  }
  .box-border {
    box-sizing: border-box;
  }
  .tema-section-stack {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-section);
  }
  .line-clamp-1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .inline-grid {
    display: inline-grid;
  }
  .table {
    display: table;
  }
  .aspect-\\[5\\/4\\] {
    aspect-ratio: 5/4;
  }
  .aspect-\\[16\\/9\\] {
    aspect-ratio: 16/9;
  }
  .aspect-video {
    aspect-ratio: var(--aspect-video);
  }
  .scrollbar-slim {
    scrollbar-width: thin;
    scrollbar-color: rgba(192, 198, 214, 0.6) transparent;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(192, 198, 214, 0.6);
      border-radius: 9999px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: rgba(150, 158, 178, 0.8);
    }
  }
  .size-1\\.5 {
    width: calc(var(--spacing) * 1.5);
    height: calc(var(--spacing) * 1.5);
  }
  .size-2 {
    width: var(--spacing-2);
    height: var(--spacing-2);
  }
  .size-2\\.5 {
    width: calc(var(--spacing) * 2.5);
    height: calc(var(--spacing) * 2.5);
  }
  .size-3 {
    width: var(--spacing-3);
    height: var(--spacing-3);
  }
  .size-3\\.5 {
    width: calc(var(--spacing) * 3.5);
    height: calc(var(--spacing) * 3.5);
  }
  .size-4 {
    width: var(--spacing-4);
    height: var(--spacing-4);
  }
  .size-5 {
    width: var(--spacing-5);
    height: var(--spacing-5);
  }
  .size-6 {
    width: var(--spacing-6);
    height: var(--spacing-6);
  }
  .size-7 {
    width: var(--spacing-7);
    height: var(--spacing-7);
  }
  .size-8 {
    width: var(--spacing-8);
    height: var(--spacing-8);
  }
  .size-9 {
    width: calc(var(--spacing) * 9);
    height: calc(var(--spacing) * 9);
  }
  .size-10 {
    width: var(--spacing-10);
    height: var(--spacing-10);
  }
  .size-11 {
    width: calc(var(--spacing) * 11);
    height: calc(var(--spacing) * 11);
  }
  .size-12 {
    width: var(--spacing-12);
    height: var(--spacing-12);
  }
  .size-14 {
    width: calc(var(--spacing) * 14);
    height: calc(var(--spacing) * 14);
  }
  .size-16 {
    width: calc(var(--spacing) * 16);
    height: calc(var(--spacing) * 16);
  }
  .size-20 {
    width: calc(var(--spacing) * 20);
    height: calc(var(--spacing) * 20);
  }
  .size-32 {
    width: calc(var(--spacing) * 32);
    height: calc(var(--spacing) * 32);
  }
  .size-40 {
    width: calc(var(--spacing) * 40);
    height: calc(var(--spacing) * 40);
  }
  .size-48 {
    width: calc(var(--spacing) * 48);
    height: calc(var(--spacing) * 48);
  }
  .size-96 {
    width: calc(var(--spacing) * 96);
    height: calc(var(--spacing) * 96);
  }
  .size-\\[6px\\] {
    width: 6px;
    height: 6px;
  }
  .size-\\[9\\.333px\\] {
    width: 9.333px;
    height: 9.333px;
  }
  .size-\\[13\\.456px\\] {
    width: 13.456px;
    height: 13.456px;
  }
  .size-\\[13px\\] {
    width: 13px;
    height: 13px;
  }
  .size-\\[16px\\] {
    width: 16px;
    height: 16px;
  }
  .size-\\[17\\.058px\\] {
    width: 17.058px;
    height: 17.058px;
  }
  .size-\\[19px\\] {
    width: 19px;
    height: 19px;
  }
  .size-\\[20px\\] {
    width: 20px;
    height: 20px;
  }
  .size-\\[30px\\] {
    width: 30px;
    height: 30px;
  }
  .size-\\[34px\\] {
    width: 34px;
    height: 34px;
  }
  .size-\\[36px\\] {
    width: 36px;
    height: 36px;
  }
  .size-\\[38px\\] {
    width: 38px;
    height: 38px;
  }
  .size-\\[40px\\] {
    width: 40px;
    height: 40px;
  }
  .size-\\[42px\\] {
    width: 42px;
    height: 42px;
  }
  .size-\\[48px\\] {
    width: 48px;
    height: 48px;
  }
  .size-\\[131px\\] {
    width: 131px;
    height: 131px;
  }
  .size-\\[192px\\] {
    width: 192px;
    height: 192px;
  }
  .size-\\[512px\\] {
    width: 512px;
    height: 512px;
  }
  .size-full {
    width: 100%;
    height: 100%;
  }
  .h-0\\.5 {
    height: calc(var(--spacing) * 0.5);
  }
  .h-1 {
    height: var(--spacing-1);
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-2 {
    height: var(--spacing-2);
  }
  .h-3 {
    height: var(--spacing-3);
  }
  .h-3\\.5 {
    height: calc(var(--spacing) * 3.5);
  }
  .h-4 {
    height: var(--spacing-4);
  }
  .h-5 {
    height: var(--spacing-5);
  }
  .h-6 {
    height: var(--spacing-6);
  }
  .h-7 {
    height: var(--spacing-7);
  }
  .h-8 {
    height: var(--spacing-8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: var(--spacing-10);
  }
  .h-11 {
    height: calc(var(--spacing) * 11);
  }
  .h-12 {
    height: var(--spacing-12);
  }
  .h-14 {
    height: calc(var(--spacing) * 14);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-20 {
    height: calc(var(--spacing) * 20);
  }
  .h-24 {
    height: calc(var(--spacing) * 24);
  }
  .h-28 {
    height: calc(var(--spacing) * 28);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-36 {
    height: calc(var(--spacing) * 36);
  }
  .h-40 {
    height: calc(var(--spacing) * 40);
  }
  .h-44 {
    height: calc(var(--spacing) * 44);
  }
  .h-48 {
    height: calc(var(--spacing) * 48);
  }
  .h-52 {
    height: calc(var(--spacing) * 52);
  }
  .h-56 {
    height: calc(var(--spacing) * 56);
  }
  .h-60 {
    height: calc(var(--spacing) * 60);
  }
  .h-72 {
    height: calc(var(--spacing) * 72);
  }
  .h-\\[5\\.649px\\] {
    height: 5.649px;
  }
  .h-\\[7px\\] {
    height: 7px;
  }
  .h-\\[11\\.083px\\] {
    height: 11.083px;
  }
  .h-\\[14px\\] {
    height: 14px;
  }
  .h-\\[15\\.776px\\] {
    height: 15.776px;
  }
  .h-\\[18px\\] {
    height: 18px;
  }
  .h-\\[20px\\] {
    height: 20px;
  }
  .h-\\[25px\\] {
    height: 25px;
  }
  .h-\\[30px\\] {
    height: 30px;
  }
  .h-\\[34px\\] {
    height: 34px;
  }
  .h-\\[36px\\] {
    height: 36px;
  }
  .h-\\[38px\\] {
    height: 38px;
  }
  .h-\\[40px\\] {
    height: 40px;
  }
  .h-\\[47px\\] {
    height: 47px;
  }
  .h-\\[50px\\] {
    height: 50px;
  }
  .h-\\[52px\\] {
    height: 52px;
  }
  .h-\\[58px\\] {
    height: 58px;
  }
  .h-\\[60px\\] {
    height: 60px;
  }
  .h-\\[61\\.631px\\] {
    height: 61.631px;
  }
  .h-\\[62px\\] {
    height: 62px;
  }
  .h-\\[64px\\] {
    height: 64px;
  }
  .h-\\[72px\\] {
    height: 72px;
  }
  .h-\\[78\\.131px\\] {
    height: 78.131px;
  }
  .h-\\[88px\\] {
    height: 88px;
  }
  .h-\\[95\\.447px\\] {
    height: 95.447px;
  }
  .h-\\[98px\\] {
    height: 98px;
  }
  .h-\\[100px\\] {
    height: 100px;
  }
  .h-\\[103px\\] {
    height: 103px;
  }
  .h-\\[105\\.99px\\] {
    height: 105.99px;
  }
  .h-\\[121px\\] {
    height: 121px;
  }
  .h-\\[131\\.56\\%\\] {
    height: 131.56%;
  }
  .h-\\[132px\\] {
    height: 132px;
  }
  .h-\\[168px\\] {
    height: 168px;
  }
  .h-\\[200px\\] {
    height: 200px;
  }
  .h-\\[244px\\] {
    height: 244px;
  }
  .h-\\[264px\\] {
    height: 264px;
  }
  .h-\\[280px\\] {
    height: 280px;
  }
  .h-\\[339px\\] {
    height: 339px;
  }
  .h-\\[347px\\] {
    height: 347px;
  }
  .h-\\[550px\\] {
    height: 550px;
  }
  .h-\\[620px\\] {
    height: 620px;
  }
  .h-\\[680px\\] {
    height: 680px;
  }
  .h-\\[907px\\] {
    height: 907px;
  }
  .h-auto {
    height: auto;
  }
  .h-dvh {
    height: 100dvh;
  }
  .h-full {
    height: 100%;
  }
  .h-px {
    height: 1px;
  }
  .max-h-5 {
    max-height: var(--spacing-5);
  }
  .max-h-6 {
    max-height: var(--spacing-6);
  }
  .max-h-7 {
    max-height: var(--spacing-7);
  }
  .max-h-36 {
    max-height: calc(var(--spacing) * 36);
  }
  .max-h-48 {
    max-height: calc(var(--spacing) * 48);
  }
  .max-h-60 {
    max-height: calc(var(--spacing) * 60);
  }
  .max-h-72 {
    max-height: calc(var(--spacing) * 72);
  }
  .max-h-\\[90vh\\] {
    max-height: 90vh;
  }
  .max-h-\\[120px\\] {
    max-height: 120px;
  }
  .max-h-\\[180px\\] {
    max-height: 180px;
  }
  .max-h-\\[200px\\] {
    max-height: 200px;
  }
  .max-h-\\[280px\\] {
    max-height: 280px;
  }
  .max-h-\\[326px\\] {
    max-height: 326px;
  }
  .max-h-\\[420px\\] {
    max-height: 420px;
  }
  .max-h-\\[480px\\] {
    max-height: 480px;
  }
  .max-h-\\[calc\\(100dvh-32px\\)\\] {
    max-height: calc(100dvh - 32px);
  }
  .max-h-\\[min\\(92vh\\,820px\\)\\] {
    max-height: min(92vh, 820px);
  }
  .max-h-full {
    max-height: 100%;
  }
  .min-h-0 {
    min-height: var(--spacing-0);
  }
  .min-h-5 {
    min-height: var(--spacing-5);
  }
  .min-h-32 {
    min-height: calc(var(--spacing) * 32);
  }
  .min-h-\\[9rem\\] {
    min-height: 9rem;
  }
  .min-h-\\[10rem\\] {
    min-height: 10rem;
  }
  .min-h-\\[24px\\] {
    min-height: 24px;
  }
  .min-h-\\[48px\\] {
    min-height: 48px;
  }
  .min-h-\\[60px\\] {
    min-height: 60px;
  }
  .min-h-\\[72px\\] {
    min-height: 72px;
  }
  .min-h-\\[92px\\] {
    min-height: 92px;
  }
  .min-h-\\[103px\\] {
    min-height: 103px;
  }
  .min-h-\\[108px\\] {
    min-height: 108px;
  }
  .min-h-\\[116px\\] {
    min-height: 116px;
  }
  .min-h-\\[160px\\] {
    min-height: 160px;
  }
  .min-h-\\[168px\\] {
    min-height: 168px;
  }
  .min-h-\\[180px\\] {
    min-height: 180px;
  }
  .min-h-\\[200px\\] {
    min-height: 200px;
  }
  .min-h-\\[220px\\] {
    min-height: 220px;
  }
  .min-h-\\[280px\\] {
    min-height: 280px;
  }
  .min-h-\\[300px\\] {
    min-height: 300px;
  }
  .min-h-\\[313px\\] {
    min-height: 313px;
  }
  .min-h-\\[320px\\] {
    min-height: 320px;
  }
  .min-h-\\[380px\\] {
    min-height: 380px;
  }
  .min-h-\\[420px\\] {
    min-height: 420px;
  }
  .min-h-dvh {
    min-height: 100dvh;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .scrollbar-filter {
    scrollbar-width: thin;
    scrollbar-color: #e1e4e8 transparent;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #e1e4e8;
      border-radius: 4px;
    }
  }
  .w-0\\.5 {
    width: calc(var(--spacing) * 0.5);
  }
  .w-1 {
    width: var(--spacing-1);
  }
  .w-1\\.5 {
    width: calc(var(--spacing) * 1.5);
  }
  .w-1\\/2 {
    width: calc(1 / 2 * 100%);
  }
  .w-1\\/3 {
    width: calc(1 / 3 * 100%);
  }
  .w-2 {
    width: var(--spacing-2);
  }
  .w-2\\/3 {
    width: calc(2 / 3 * 100%);
  }
  .w-3 {
    width: var(--spacing-3);
  }
  .w-3\\.5 {
    width: calc(var(--spacing) * 3.5);
  }
  .w-3\\/4 {
    width: calc(3 / 4 * 100%);
  }
  .w-4 {
    width: var(--spacing-4);
  }
  .w-4\\/5 {
    width: calc(4 / 5 * 100%);
  }
  .w-5 {
    width: var(--spacing-5);
  }
  .w-6 {
    width: var(--spacing-6);
  }
  .w-7 {
    width: var(--spacing-7);
  }
  .w-8 {
    width: var(--spacing-8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-10 {
    width: var(--spacing-10);
  }
  .w-12 {
    width: var(--spacing-12);
  }
  .w-14 {
    width: calc(var(--spacing) * 14);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-28 {
    width: calc(var(--spacing) * 28);
  }
  .w-32 {
    width: calc(var(--spacing) * 32);
  }
  .w-40 {
    width: calc(var(--spacing) * 40);
  }
  .w-44 {
    width: calc(var(--spacing) * 44);
  }
  .w-48 {
    width: calc(var(--spacing) * 48);
  }
  .w-52 {
    width: calc(var(--spacing) * 52);
  }
  .w-56 {
    width: calc(var(--spacing) * 56);
  }
  .w-64 {
    width: calc(var(--spacing) * 64);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-\\[10\\.5px\\] {
    width: 10.5px;
  }
  .w-\\[11\\.667px\\] {
    width: 11.667px;
  }
  .w-\\[16px\\] {
    width: 16px;
  }
  .w-\\[17px\\] {
    width: 17px;
  }
  .w-\\[20px\\] {
    width: 20px;
  }
  .w-\\[22px\\] {
    width: 22px;
  }
  .w-\\[23\\.223px\\] {
    width: 23.223px;
  }
  .w-\\[30px\\] {
    width: 30px;
  }
  .w-\\[44px\\] {
    width: 44px;
  }
  .w-\\[48px\\] {
    width: 48px;
  }
  .w-\\[52\\%\\] {
    width: 52%;
  }
  .w-\\[53\\.64px\\] {
    width: 53.64px;
  }
  .w-\\[68px\\] {
    width: 68px;
  }
  .w-\\[72px\\] {
    width: 72px;
  }
  .w-\\[78\\%\\] {
    width: 78%;
  }
  .w-\\[88px\\] {
    width: 88px;
  }
  .w-\\[92\\%\\] {
    width: 92%;
  }
  .w-\\[140px\\] {
    width: 140px;
  }
  .w-\\[153px\\] {
    width: 153px;
  }
  .w-\\[169px\\] {
    width: 169px;
  }
  .w-\\[175px\\] {
    width: 175px;
  }
  .w-\\[180px\\] {
    width: 180px;
  }
  .w-\\[184px\\] {
    width: 184px;
  }
  .w-\\[200px\\] {
    width: 200px;
  }
  .w-\\[208px\\] {
    width: 208px;
  }
  .w-\\[240px\\] {
    width: 240px;
  }
  .w-\\[252px\\] {
    width: 252px;
  }
  .w-\\[255px\\] {
    width: 255px;
  }
  .w-\\[259\\.66\\%\\] {
    width: 259.66%;
  }
  .w-\\[260\\.95px\\] {
    width: 260.95px;
  }
  .w-\\[263\\.824px\\] {
    width: 263.824px;
  }
  .w-\\[264px\\] {
    width: 264px;
  }
  .w-\\[265px\\] {
    width: 265px;
  }
  .w-\\[330\\.811px\\] {
    width: 330.811px;
  }
  .w-\\[330px\\] {
    width: 330px;
  }
  .w-\\[334\\.454px\\] {
    width: 334.454px;
  }
  .w-\\[364px\\] {
    width: 364px;
  }
  .w-\\[436px\\] {
    width: 436px;
  }
  .w-\\[450px\\] {
    width: 450px;
  }
  .w-\\[453px\\] {
    width: 453px;
  }
  .w-\\[488px\\] {
    width: 488px;
  }
  .w-\\[514\\.738px\\] {
    width: 514.738px;
  }
  .w-\\[610\\.67px\\] {
    width: 610.67px;
  }
  .w-\\[612px\\] {
    width: 612px;
  }
  .w-\\[613px\\] {
    width: 613px;
  }
  .w-\\[640px\\] {
    width: 640px;
  }
  .w-\\[1099px\\] {
    width: 1099px;
  }
  .w-\\[1176px\\] {
    width: 1176px;
  }
  .w-\\[min\\(424px\\,calc\\(100vw-32px\\)\\)\\] {
    width: min(424px, calc(100vw - 32px));
  }
  .w-auto {
    width: auto;
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-max {
    width: max-content;
  }
  .w-px {
    width: 1px;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-3xl {
    max-width: var(--container-3xl);
  }
  .max-w-4xl {
    max-width: var(--container-4xl);
  }
  .max-w-5 {
    max-width: var(--spacing-5);
  }
  .max-w-5xl {
    max-width: var(--container-5xl);
  }
  .max-w-6 {
    max-width: var(--spacing-6);
  }
  .max-w-7 {
    max-width: var(--spacing-7);
  }
  .max-w-\\[16rem\\] {
    max-width: 16rem;
  }
  .max-w-\\[56px\\] {
    max-width: 56px;
  }
  .max-w-\\[80\\%\\] {
    max-width: 80%;
  }
  .max-w-\\[160px\\] {
    max-width: 160px;
  }
  .max-w-\\[220px\\] {
    max-width: 220px;
  }
  .max-w-\\[240px\\] {
    max-width: 240px;
  }
  .max-w-\\[330px\\] {
    max-width: 330px;
  }
  .max-w-\\[357px\\] {
    max-width: 357px;
  }
  .max-w-\\[420px\\] {
    max-width: 420px;
  }
  .max-w-\\[440px\\] {
    max-width: 440px;
  }
  .max-w-\\[460px\\] {
    max-width: 460px;
  }
  .max-w-\\[496px\\] {
    max-width: 496px;
  }
  .max-w-\\[508px\\] {
    max-width: 508px;
  }
  .max-w-\\[512px\\] {
    max-width: 512px;
  }
  .max-w-\\[647px\\] {
    max-width: 647px;
  }
  .max-w-\\[678px\\] {
    max-width: 678px;
  }
  .max-w-\\[704px\\] {
    max-width: 704px;
  }
  .max-w-\\[800px\\] {
    max-width: 800px;
  }
  .max-w-\\[896px\\] {
    max-width: 896px;
  }
  .max-w-\\[920px\\] {
    max-width: 920px;
  }
  .max-w-\\[1077px\\] {
    max-width: 1077px;
  }
  .max-w-\\[min\\(240px\\,42\\%\\)\\] {
    max-width: min(240px, 42%);
  }
  .max-w-content-max {
    max-width: var(--spacing-content-max);
  }
  .max-w-dashboard-max {
    max-width: var(--spacing-dashboard-max);
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-lg {
    max-width: var(--container-lg);
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-none {
    max-width: none;
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .max-w-xl {
    max-width: var(--container-xl);
  }
  .max-w-xs {
    max-width: var(--container-xs);
  }
  .min-w-0 {
    min-width: var(--spacing-0);
  }
  .min-w-5 {
    min-width: var(--spacing-5);
  }
  .min-w-\\[72px\\] {
    min-width: 72px;
  }
  .min-w-\\[88px\\] {
    min-width: 88px;
  }
  .min-w-\\[120px\\] {
    min-width: 120px;
  }
  .min-w-\\[140px\\] {
    min-width: 140px;
  }
  .min-w-\\[160px\\] {
    min-width: 160px;
  }
  .min-w-\\[168px\\] {
    min-width: 168px;
  }
  .min-w-\\[180px\\] {
    min-width: 180px;
  }
  .min-w-full {
    min-width: 100%;
  }
  .min-w-px {
    min-width: 1px;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-\\[1_0_0\\] {
    flex: 1 0 0;
  }
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .shrink {
    flex-shrink: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .grow {
    flex-grow: 1;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .origin-center {
    transform-origin: center;
  }
  .origin-top {
    transform-origin: top;
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-x-full {
    --tw-translate-x: -100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-0 {
    --tw-translate-x: var(--spacing-0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-rotate-45 {
    rotate: calc(45deg * -1);
  }
  .-rotate-90 {
    rotate: calc(90deg * -1);
  }
  .rotate-0 {
    rotate: 0deg;
  }
  .rotate-12 {
    rotate: 12deg;
  }
  .rotate-45 {
    rotate: 45deg;
  }
  .rotate-180 {
    rotate: 180deg;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-\\[crafting-ring_1\\.8s_ease-in-out_infinite\\] {
    animation: crafting-ring 1.8s ease-in-out infinite;
  }
  .animate-bounce {
    animation: var(--animate-bounce);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .workspace-enter {
    animation: workspace-fade-up-in var(--duration-workspace-enter) var(--ease-workspace) both;
  }
  .workspace-overlay-enter {
    animation: workspace-fade-in var(--duration-workspace-overlay-enter) var(--ease-workspace) both;
  }
  .workspace-overlay-exit {
    animation: workspace-fade-out var(--duration-workspace-overlay-exit) ease-in both;
  }
  .workspace-skeleton-pulse {
    animation: workspace-skeleton-pulse 2s ease-in-out infinite;
  }
  .cursor-grab {
    cursor: grab;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-wait {
    cursor: wait;
  }
  .resize {
    resize: both;
  }
  .resize-none {
    resize: none;
  }
  .list-inside {
    list-style-position: inside;
  }
  .list-decimal {
    list-style-type: decimal;
  }
  .list-disc {
    list-style-type: disc;
  }
  .list-none {
    list-style-type: none;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .grid-cols-\\[1\\.1fr_1\\.6fr_1fr_0\\.9fr_auto\\] {
    grid-template-columns: 1.1fr 1.6fr 1fr 0.9fr auto;
  }
  .grid-cols-\\[1\\.05fr_0\\.85fr\\] {
    grid-template-columns: 1.05fr 0.85fr;
  }
  .grid-cols-\\[1\\.05fr_0\\.95fr\\] {
    grid-template-columns: 1.05fr 0.95fr;
  }
  .grid-cols-\\[1fr_0\\.9fr\\] {
    grid-template-columns: 1fr 0.9fr;
  }
  .grid-cols-\\[140px_1fr\\] {
    grid-template-columns: 140px 1fr;
  }
  .grid-cols-\\[max-content\\] {
    grid-template-columns: max-content;
  }
  .grid-rows-\\[max-content\\] {
    grid-template-rows: max-content;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-nowrap {
    flex-wrap: nowrap;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .place-items-start {
    place-items: start;
  }
  .content-stretch {
    align-content: stretch;
  }
  .items-baseline {
    align-items: baseline;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .items-stretch {
    align-items: stretch;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .gap-0 {
    gap: var(--spacing-0);
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: var(--spacing-1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: var(--spacing-2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-3 {
    gap: var(--spacing-3);
  }
  .gap-3\\.5 {
    gap: calc(var(--spacing) * 3.5);
  }
  .gap-4 {
    gap: var(--spacing-4);
  }
  .gap-5 {
    gap: var(--spacing-5);
  }
  .gap-6 {
    gap: var(--spacing-6);
  }
  .gap-7 {
    gap: var(--spacing-7);
  }
  .gap-8 {
    gap: var(--spacing-8);
  }
  .gap-10 {
    gap: var(--spacing-10);
  }
  .gap-12 {
    gap: var(--spacing-12);
  }
  .gap-\\[4px\\] {
    gap: 4px;
  }
  .gap-\\[5px\\] {
    gap: 5px;
  }
  .gap-\\[8px\\] {
    gap: 8px;
  }
  .gap-\\[9\\.905px\\] {
    gap: 9.905px;
  }
  .gap-\\[12px\\] {
    gap: 12px;
  }
  .gap-\\[16px\\] {
    gap: 16px;
  }
  .gap-\\[21px\\] {
    gap: 21px;
  }
  .gap-\\[22px\\] {
    gap: 22px;
  }
  .gap-\\[24px\\] {
    gap: 24px;
  }
  .gap-card-sm {
    gap: var(--spacing-card-sm);
  }
  .gap-inline {
    gap: var(--spacing-inline);
  }
  .gap-section {
    gap: var(--spacing-section);
  }
  .gap-section-lg {
    gap: var(--spacing-section-lg);
  }
  .gap-stack-sm {
    gap: var(--spacing-stack-sm);
  }
  .space-y-0 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-0) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-0) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-0\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 0.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 0.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-1) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-1) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-2) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-3 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-3) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-3) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-4) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-5) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-6) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-6) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-8 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-8) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-8) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-4 {
    column-gap: var(--spacing-4);
  }
  .gap-x-6 {
    column-gap: var(--spacing-6);
  }
  .gap-y-1 {
    row-gap: var(--spacing-1);
  }
  .gap-y-3 {
    row-gap: var(--spacing-3);
  }
  .divide-x {
    :where(& > :not(:last-child)) {
      --tw-divide-x-reverse: 0;
      border-inline-style: var(--tw-border-style);
      border-inline-start-width: calc(1px * var(--tw-divide-x-reverse));
      border-inline-end-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
    }
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
  }
  .divide-\\[\\#e2e8f0\\] {
    :where(& > :not(:last-child)) {
      border-color: #e2e8f0;
    }
  }
  .divide-slate-50 {
    :where(& > :not(:last-child)) {
      border-color: var(--color-slate-50);
    }
  }
  .divide-slate-100 {
    :where(& > :not(:last-child)) {
      border-color: var(--color-slate-100);
    }
  }
  .self-center {
    align-self: center;
  }
  .self-end {
    align-self: flex-end;
  }
  .self-start {
    align-self: flex-start;
  }
  .self-stretch {
    align-self: stretch;
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-clip {
    overflow: clip;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-visible {
    overflow: visible;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-x-clip {
    overflow-x: clip;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overscroll-contain {
    overscroll-behavior: contain;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-3xl {
    border-radius: var(--radius-3xl);
  }
  .rounded-\\[3px\\] {
    border-radius: 3px;
  }
  .rounded-\\[7px\\] {
    border-radius: 7px;
  }
  .rounded-\\[8px\\] {
    border-radius: 8px;
  }
  .rounded-\\[10px\\] {
    border-radius: 10px;
  }
  .rounded-\\[14\\.375px\\] {
    border-radius: 14.375px;
  }
  .rounded-\\[14px\\] {
    border-radius: 14px;
  }
  .rounded-\\[16px\\] {
    border-radius: 16px;
  }
  .rounded-\\[18px\\] {
    border-radius: 18px;
  }
  .rounded-\\[22px\\] {
    border-radius: 22px;
  }
  .rounded-\\[9999px\\] {
    border-radius: 9999px;
  }
  .rounded-\\[33554400px\\] {
    border-radius: 33554400px;
  }
  .rounded-\\[inherit\\] {
    border-radius: inherit;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-none {
    border-radius: 0;
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-t-2xl {
    border-top-left-radius: var(--radius-2xl);
    border-top-right-radius: var(--radius-2xl);
  }
  .rounded-r-xl {
    border-top-right-radius: var(--radius-xl);
    border-bottom-right-radius: var(--radius-xl);
  }
  .rounded-tr-\\[16px\\] {
    border-top-right-radius: 16px;
  }
  .rounded-b-xl {
    border-bottom-right-radius: var(--radius-xl);
    border-bottom-left-radius: var(--radius-xl);
  }
  .rounded-br-\\[16px\\] {
    border-bottom-right-radius: 16px;
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-\\[1\\.5px\\] {
    border-style: var(--tw-border-style);
    border-width: 1.5px;
  }
  .border-\\[5px\\] {
    border-style: var(--tw-border-style);
    border-width: 5px;
  }
  .border-x {
    border-inline-style: var(--tw-border-style);
    border-inline-width: 1px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-t-2 {
    border-top-style: var(--tw-border-style);
    border-top-width: 2px;
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-r-2 {
    border-right-style: var(--tw-border-style);
    border-right-width: 2px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-2 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
  .border-l-2 {
    border-left-style: var(--tw-border-style);
    border-left-width: 2px;
  }
  .border-l-4 {
    border-left-style: var(--tw-border-style);
    border-left-width: 4px;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-dotted {
    --tw-border-style: dotted;
    border-style: dotted;
  }
  .border-solid {
    --tw-border-style: solid;
    border-style: solid;
  }
  .border-\\[\\#1e293b\\] {
    border-color: #1e293b;
  }
  .border-\\[\\#004ac6\\] {
    border-color: #004ac6;
  }
  .border-\\[\\#7c3aed\\] {
    border-color: #7c3aed;
  }
  .border-\\[\\#8aaeca\\] {
    border-color: #8aaeca;
  }
  .border-\\[\\#8c7164\\] {
    border-color: #8c7164;
  }
  .border-\\[\\#009dff\\] {
    border-color: #009dff;
  }
  .border-\\[\\#9d4300\\] {
    border-color: #9d4300;
  }
  .border-\\[\\#9ebad4\\] {
    border-color: #9ebad4;
  }
  .border-\\[\\#16a34a\\] {
    border-color: #16a34a;
  }
  .border-\\[\\#20a466\\] {
    border-color: #20a466;
  }
  .border-\\[\\#0066ff\\] {
    border-color: #0066ff;
  }
  .border-\\[\\#86efac\\] {
    border-color: #86efac;
  }
  .border-\\[\\#2563eb\\] {
    border-color: #2563eb;
  }
  .border-\\[\\#005799\\] {
    border-color: #005799;
  }
  .border-\\[\\#059669\\] {
    border-color: #059669;
  }
  .border-\\[\\#111827\\] {
    border-color: #111827;
  }
  .border-\\[\\#434655\\] {
    border-color: #434655;
  }
  .border-\\[\\#444651\\] {
    border-color: #444651;
  }
  .border-\\[\\#757682\\] {
    border-color: #757682;
  }
  .border-\\[\\#875300\\] {
    border-color: #875300;
  }
  .border-\\[\\#a8a29e\\] {
    border-color: #a8a29e;
  }
  .border-\\[\\#b8c9dc\\] {
    border-color: #b8c9dc;
  }
  .border-\\[\\#ba1a1a\\] {
    border-color: #ba1a1a;
  }
  .border-\\[\\#bbf7d0\\] {
    border-color: #bbf7d0;
  }
  .border-\\[\\#bfdbfe\\] {
    border-color: #bfdbfe;
  }
  .border-\\[\\#c0c6d6\\] {
    border-color: #c0c6d6;
  }
  .border-\\[\\#c3c6d6\\] {
    border-color: #c3c6d6;
  }
  .border-\\[\\#c3c6d7\\] {
    border-color: #c3c6d7;
  }
  .border-\\[\\#c4b5fd\\] {
    border-color: #c4b5fd;
  }
  .border-\\[\\#c5c5d3\\] {
    border-color: #c5c5d3;
  }
  .border-\\[\\#c5c5d3\\]\\/40 {
    border-color: color-mix(in oklab, #c5c5d3 40%, transparent);
  }
  .border-\\[\\#c5c5d3\\]\\/60 {
    border-color: color-mix(in oklab, #c5c5d3 60%, transparent);
  }
  .border-\\[\\#c5d6e8\\] {
    border-color: #c5d6e8;
  }
  .border-\\[\\#cbc4d2\\] {
    border-color: #cbc4d2;
  }
  .border-\\[\\#cbd5e1\\] {
    border-color: #cbd5e1;
  }
  .border-\\[\\#d1d5db\\] {
    border-color: #d1d5db;
  }
  .border-\\[\\#d6d3d1\\] {
    border-color: #d6d3d1;
  }
  .border-\\[\\#d8e6f5\\] {
    border-color: #d8e6f5;
  }
  .border-\\[\\#db2777\\] {
    border-color: #db2777;
  }
  .border-\\[\\#dbeafe\\] {
    border-color: #dbeafe;
  }
  .border-\\[\\#dce3ed\\] {
    border-color: #dce3ed;
  }
  .border-\\[\\#e0c0b1\\] {
    border-color: #e0c0b1;
  }
  .border-\\[\\#e0c0b1\\]\\/40 {
    border-color: color-mix(in oklab, #e0c0b1 40%, transparent);
  }
  .border-\\[\\#e2e7ef\\] {
    border-color: #e2e7ef;
  }
  .border-\\[\\#e2e8f0\\] {
    border-color: #e2e8f0;
  }
  .border-\\[\\#e5e7eb\\] {
    border-color: #e5e7eb;
  }
  .border-\\[\\#e7e5e4\\] {
    border-color: #e7e5e4;
  }
  .border-\\[\\#e8ecf2\\] {
    border-color: #e8ecf2;
  }
  .border-\\[\\#e8edf2\\] {
    border-color: #e8edf2;
  }
  .border-\\[\\#e9d5ff\\] {
    border-color: #e9d5ff;
  }
  .border-\\[\\#eef2f6\\] {
    border-color: #eef2f6;
  }
  .border-\\[\\#eef2f7\\] {
    border-color: #eef2f7;
  }
  .border-\\[\\#f1f5f9\\] {
    border-color: #f1f5f9;
  }
  .border-\\[\\#f3f4f6\\] {
    border-color: #f3f4f6;
  }
  .border-\\[\\#f5ae33\\] {
    border-color: #f5ae33;
  }
  .border-\\[\\#f08a00\\] {
    border-color: #f08a00;
  }
  .border-\\[\\#f9cc8a\\] {
    border-color: #f9cc8a;
  }
  .border-\\[\\#f9ebd8\\] {
    border-color: #f9ebd8;
  }
  .border-\\[\\#f59e0b\\] {
    border-color: #f59e0b;
  }
  .border-\\[\\#f19500\\] {
    border-color: #f19500;
  }
  .border-\\[\\#f87171\\] {
    border-color: #f87171;
  }
  .border-\\[\\#f97316\\] {
    border-color: #f97316;
  }
  .border-\\[\\#fbcfe8\\] {
    border-color: #fbcfe8;
  }
  .border-\\[\\#fcd34d\\] {
    border-color: #fcd34d;
  }
  .border-\\[\\#fce4a8\\] {
    border-color: #fce4a8;
  }
  .border-\\[\\#fda29b\\] {
    border-color: #fda29b;
  }
  .border-\\[\\#fde4c4\\] {
    border-color: #fde4c4;
  }
  .border-\\[\\#fecaca\\] {
    border-color: #fecaca;
  }
  .border-\\[\\#fecdca\\] {
    border-color: #fecdca;
  }
  .border-\\[\\#fecdd3\\] {
    border-color: #fecdd3;
  }
  .border-\\[\\#ffb68f\\] {
    border-color: #ffb68f;
  }
  .border-\\[\\#ffdad6\\] {
    border-color: #ffdad6;
  }
  .border-\\[rgba\\(0\\,0\\,0\\,0\\)\\] {
    border-color: rgba(0,0,0,0);
  }
  .border-\\[rgba\\(0\\,74\\,49\\,0\\.2\\)\\] {
    border-color: rgba(0,74,49,0.2);
  }
  .border-\\[rgba\\(0\\,74\\,198\\,0\\.1\\)\\] {
    border-color: rgba(0,74,198,0.1);
  }
  .border-\\[rgba\\(0\\,74\\,198\\,0\\.2\\)\\] {
    border-color: rgba(0,74,198,0.2);
  }
  .border-\\[rgba\\(49\\,107\\,243\\,0\\.4\\)\\] {
    border-color: rgba(49,107,243,0.4);
  }
  .border-\\[rgba\\(79\\,55\\,138\\,0\\.4\\)\\] {
    border-color: rgba(79,55,138,0.4);
  }
  .border-\\[rgba\\(99\\,89\\,124\\,0\\.3\\)\\] {
    border-color: rgba(99,89,124,0.3);
  }
  .border-\\[rgba\\(119\\,119\\,119\\,0\\.1\\)\\] {
    border-color: rgba(119,119,119,0.1);
  }
  .border-\\[rgba\\(135\\,83\\,0\\,0\\.2\\)\\] {
    border-color: rgba(135,83,0,0.2);
  }
  .border-\\[rgba\\(135\\,83\\,0\\,0\\.15\\)\\] {
    border-color: rgba(135,83,0,0.15);
  }
  .border-\\[rgba\\(135\\,83\\,0\\,0\\.18\\)\\] {
    border-color: rgba(135,83,0,0.18);
  }
  .border-\\[rgba\\(135\\,83\\,0\\,0\\.25\\)\\] {
    border-color: rgba(135,83,0,0.25);
  }
  .border-\\[rgba\\(192\\,198\\,214\\,0\\.2\\)\\] {
    border-color: rgba(192,198,214,0.2);
  }
  .border-\\[rgba\\(192\\,198\\,214\\,0\\.3\\)\\] {
    border-color: rgba(192,198,214,0.3);
  }
  .border-\\[rgba\\(192\\,198\\,214\\,0\\.25\\)\\] {
    border-color: rgba(192,198,214,0.25);
  }
  .border-\\[rgba\\(192\\,198\\,214\\,0\\.35\\)\\] {
    border-color: rgba(192,198,214,0.35);
  }
  .border-\\[rgba\\(195\\,198\\,215\\,0\\.2\\)\\] {
    border-color: rgba(195,198,215,0.2);
  }
  .border-\\[rgba\\(195\\,198\\,215\\,0\\.3\\)\\] {
    border-color: rgba(195,198,215,0.3);
  }
  .border-\\[rgba\\(195\\,198\\,215\\,0\\.4\\)\\] {
    border-color: rgba(195,198,215,0.4);
  }
  .border-\\[rgba\\(195\\,198\\,215\\,0\\.5\\)\\] {
    border-color: rgba(195,198,215,0.5);
  }
  .border-\\[rgba\\(197\\,197\\,211\\,0\\.5\\)\\] {
    border-color: rgba(197,197,211,0.5);
  }
  .border-\\[rgba\\(197\\,197\\,211\\,0\\.6\\)\\] {
    border-color: rgba(197,197,211,0.6);
  }
  .border-\\[rgba\\(197\\,197\\,211\\,0\\.8\\)\\] {
    border-color: rgba(197,197,211,0.8);
  }
  .border-\\[rgba\\(197\\,198\\,205\\,0\\.2\\)\\] {
    border-color: rgba(197,198,205,0.2);
  }
  .border-\\[rgba\\(197\\,198\\,205\\,0\\.4\\)\\] {
    border-color: rgba(197,198,205,0.4);
  }
  .border-\\[rgba\\(197\\,198\\,205\\,0\\.6\\)\\] {
    border-color: rgba(197,198,205,0.6);
  }
  .border-\\[rgba\\(197\\,198\\,205\\,0\\.35\\)\\] {
    border-color: rgba(197,198,205,0.35);
  }
  .border-\\[rgba\\(201\\,167\\,77\\,0\\.2\\)\\] {
    border-color: rgba(201,167,77,0.2);
  }
  .border-\\[rgba\\(201\\,167\\,77\\,0\\.3\\)\\] {
    border-color: rgba(201,167,77,0.3);
  }
  .border-\\[rgba\\(203\\,196\\,210\\,0\\.3\\)\\] {
    border-color: rgba(203,196,210,0.3);
  }
  .border-\\[rgba\\(224\\,192\\,177\\,0\\.2\\)\\] {
    border-color: rgba(224,192,177,0.2);
  }
  .border-\\[rgba\\(245\\,158\\,11\\,0\\.45\\)\\] {
    border-color: rgba(245,158,11,0.45);
  }
  .border-\\[transparent\\] {
    border-color: transparent;
  }
  .border-amber-200 {
    border-color: var(--color-amber-200);
  }
  .border-black\\/10 {
    border-color: color-mix(in srgb, #000 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-black) 10%, transparent);
    }
  }
  .border-blue-400 {
    border-color: var(--color-blue-400);
  }
  .border-green-200 {
    border-color: var(--color-green-200);
  }
  .border-green-500 {
    border-color: var(--color-green-500);
  }
  .border-indigo-100 {
    border-color: var(--color-indigo-100);
  }
  .border-indigo-200 {
    border-color: var(--color-indigo-200);
  }
  .border-primary {
    border-color: var(--color-primary);
  }
  .border-primary\\/25 {
    border-color: color-mix(in srgb, #f19500 25%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-primary) 25%, transparent);
    }
  }
  .border-primary\\/35 {
    border-color: color-mix(in srgb, #f19500 35%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-primary) 35%, transparent);
    }
  }
  .border-red-100 {
    border-color: var(--color-red-100);
  }
  .border-red-200 {
    border-color: var(--color-red-200);
  }
  .border-red-400 {
    border-color: var(--color-red-400);
  }
  .border-secondary {
    border-color: var(--color-secondary);
  }
  .border-secondary\\/30 {
    border-color: color-mix(in srgb, #009dff 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-secondary) 30%, transparent);
    }
  }
  .border-slate-50 {
    border-color: var(--color-slate-50);
  }
  .border-slate-100 {
    border-color: var(--color-slate-100);
  }
  .border-slate-200 {
    border-color: var(--color-slate-200);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-white {
    border-color: var(--color-white);
  }
  .border-white\\/20 {
    border-color: color-mix(in srgb, #fff 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 20%, transparent);
    }
  }
  .border-white\\/25 {
    border-color: color-mix(in srgb, #fff 25%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 25%, transparent);
    }
  }
  .border-white\\/30 {
    border-color: color-mix(in srgb, #fff 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 30%, transparent);
    }
  }
  .border-white\\/70 {
    border-color: color-mix(in srgb, #fff 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 70%, transparent);
    }
  }
  .border-t-\\[\\#191b23\\] {
    border-top-color: #191b23;
  }
  .border-t-transparent {
    border-top-color: transparent;
  }
  .border-l-\\[\\#16a34a\\] {
    border-left-color: #16a34a;
  }
  .border-l-\\[rgba\\(0\\,74\\,198\\,0\\.2\\)\\] {
    border-left-color: rgba(0,74,198,0.2);
  }
  .bg-\\[\\#0b1c30\\] {
    background-color: #0b1c30;
  }
  .bg-\\[\\#0f172a\\] {
    background-color: #0f172a;
  }
  .bg-\\[\\#0f172a\\]\\/35 {
    background-color: color-mix(in oklab, #0f172a 35%, transparent);
  }
  .bg-\\[\\#0f172a\\]\\/45 {
    background-color: color-mix(in oklab, #0f172a 45%, transparent);
  }
  .bg-\\[\\#0f172a\\]\\/50 {
    background-color: color-mix(in oklab, #0f172a 50%, transparent);
  }
  .bg-\\[\\#1f2937\\] {
    background-color: #1f2937;
  }
  .bg-\\[\\#3b82f6\\] {
    background-color: #3b82f6;
  }
  .bg-\\[\\#006BB6\\] {
    background-color: #006BB6;
  }
  .bg-\\[\\#7c3aed\\] {
    background-color: #7c3aed;
  }
  .bg-\\[\\#7dd3fc\\] {
    background-color: #7dd3fc;
  }
  .bg-\\[\\#009dff\\] {
    background-color: #009dff;
  }
  .bg-\\[\\#16a34a\\] {
    background-color: #16a34a;
  }
  .bg-\\[\\#20a466\\] {
    background-color: #20a466;
  }
  .bg-\\[\\#22c55e\\] {
    background-color: #22c55e;
  }
  .bg-\\[\\#60a5fa\\] {
    background-color: #60a5fa;
  }
  .bg-\\[\\#191b23\\] {
    background-color: #191b23;
  }
  .bg-\\[\\#2563eb\\] {
    background-color: #2563eb;
  }
  .bg-\\[\\#9333ea\\] {
    background-color: #9333ea;
  }
  .bg-\\[\\#059669\\] {
    background-color: #059669;
  }
  .bg-\\[\\#085891\\] {
    background-color: #085891;
  }
  .bg-\\[\\#111827\\] {
    background-color: #111827;
  }
  .bg-\\[\\#855300\\] {
    background-color: #855300;
  }
  .bg-\\[\\#875300\\] {
    background-color: #875300;
  }
  .bg-\\[\\#F973161A\\] {
    background-color: #F973161A;
  }
  .bg-\\[\\#c0c6d6\\] {
    background-color: #c0c6d6;
  }
  .bg-\\[\\#d3e4fe\\] {
    background-color: #d3e4fe;
  }
  .bg-\\[\\#d5e3ff\\] {
    background-color: #d5e3ff;
  }
  .bg-\\[\\#d9e8f5\\] {
    background-color: #d9e8f5;
  }
  .bg-\\[\\#d4183d\\] {
    background-color: #d4183d;
  }
  .bg-\\[\\#dbe1ff\\] {
    background-color: #dbe1ff;
  }
  .bg-\\[\\#dbeafe\\] {
    background-color: #dbeafe;
  }
  .bg-\\[\\#dce9ff\\] {
    background-color: #dce9ff;
  }
  .bg-\\[\\#dcfce7\\] {
    background-color: #dcfce7;
  }
  .bg-\\[\\#e2ad37\\] {
    background-color: #e2ad37;
  }
  .bg-\\[\\#e2e7ef\\] {
    background-color: #e2e7ef;
  }
  .bg-\\[\\#e2e8f0\\] {
    background-color: #e2e8f0;
  }
  .bg-\\[\\#e5e5e5\\] {
    background-color: #e5e5e5;
  }
  .bg-\\[\\#e5e7eb\\] {
    background-color: #e5e7eb;
  }
  .bg-\\[\\#e5eeff\\] {
    background-color: #e5eeff;
  }
  .bg-\\[\\#e6e0e9\\] {
    background-color: #e6e0e9;
  }
  .bg-\\[\\#e7f7ef\\] {
    background-color: #e7f7ef;
  }
  .bg-\\[\\#e8ecf2\\] {
    background-color: #e8ecf2;
  }
  .bg-\\[\\#eceef0\\] {
    background-color: #eceef0;
  }
  .bg-\\[\\#ecf9f2\\] {
    background-color: #ecf9f2;
  }
  .bg-\\[\\#ecfdf5\\] {
    background-color: #ecfdf5;
  }
  .bg-\\[\\#ede9fe\\] {
    background-color: #ede9fe;
  }
  .bg-\\[\\#eef2f6\\] {
    background-color: #eef2f6;
  }
  .bg-\\[\\#eff4ff\\] {
    background-color: #eff4ff;
  }
  .bg-\\[\\#eff6ff\\] {
    background-color: #eff6ff;
  }
  .bg-\\[\\#eff7ff\\] {
    background-color: #eff7ff;
  }
  .bg-\\[\\#f0fdf4\\] {
    background-color: #f0fdf4;
  }
  .bg-\\[\\#f1edff\\] {
    background-color: #f1edff;
  }
  .bg-\\[\\#f1f3fe\\] {
    background-color: #f1f3fe;
  }
  .bg-\\[\\#f1f5f9\\] {
    background-color: #f1f5f9;
  }
  .bg-\\[\\#f2f4f7\\] {
    background-color: #f2f4f7;
  }
  .bg-\\[\\#f3f4f6\\] {
    background-color: #f3f4f6;
  }
  .bg-\\[\\#f3f4f6\\]\\/95 {
    background-color: color-mix(in oklab, #f3f4f6 95%, transparent);
  }
  .bg-\\[\\#f3f5f9\\] {
    background-color: #f3f5f9;
  }
  .bg-\\[\\#f5f3ff\\] {
    background-color: #f5f3ff;
  }
  .bg-\\[\\#f5f6fb\\] {
    background-color: #f5f6fb;
  }
  .bg-\\[\\#f7f8fb\\] {
    background-color: #f7f8fb;
  }
  .bg-\\[\\#f8f2fa\\] {
    background-color: #f8f2fa;
  }
  .bg-\\[\\#f8f9ff\\] {
    background-color: #f8f9ff;
  }
  .bg-\\[\\#f8fafc\\] {
    background-color: #f8fafc;
  }
  .bg-\\[\\#f8fbff\\] {
    background-color: #f8fbff;
  }
  .bg-\\[\\#f9cc8a\\] {
    background-color: #f9cc8a;
  }
  .bg-\\[\\#f9fafb\\] {
    background-color: #f9fafb;
  }
  .bg-\\[\\#f28a00\\] {
    background-color: #f28a00;
  }
  .bg-\\[\\#f59f0a\\] {
    background-color: #f59f0a;
  }
  .bg-\\[\\#f19500\\] {
    background-color: #f19500;
  }
  .bg-\\[\\#f97316\\] {
    background-color: #f97316;
  }
  .bg-\\[\\#faf5ff\\] {
    background-color: #faf5ff;
  }
  .bg-\\[\\#fafaf9\\] {
    background-color: #fafaf9;
  }
  .bg-\\[\\#fafafa\\] {
    background-color: #fafafa;
  }
  .bg-\\[\\#fafbff\\] {
    background-color: #fafbff;
  }
  .bg-\\[\\#fbbf24\\] {
    background-color: #fbbf24;
  }
  .bg-\\[\\#fce7f3\\] {
    background-color: #fce7f3;
  }
  .bg-\\[\\#fde4c4\\] {
    background-color: #fde4c4;
  }
  .bg-\\[\\#fdf2f8\\] {
    background-color: #fdf2f8;
  }
  .bg-\\[\\#fdfeff\\] {
    background-color: #fdfeff;
  }
  .bg-\\[\\#fee2e2\\] {
    background-color: #fee2e2;
  }
  .bg-\\[\\#fef2f2\\] {
    background-color: #fef2f2;
  }
  .bg-\\[\\#fef3c7\\] {
    background-color: #fef3c7;
  }
  .bg-\\[\\#fef3f2\\] {
    background-color: #fef3f2;
  }
  .bg-\\[\\#fefefe\\] {
    background-color: #fefefe;
  }
  .bg-\\[\\#ff5d5d\\] {
    background-color: #ff5d5d;
  }
  .bg-\\[\\#ffe5d1\\] {
    background-color: #ffe5d1;
  }
  .bg-\\[\\#fff0d9\\] {
    background-color: #fff0d9;
  }
  .bg-\\[\\#fff5f5\\] {
    background-color: #fff5f5;
  }
  .bg-\\[\\#fff7ea\\] {
    background-color: #fff7ea;
  }
  .bg-\\[\\#fff7ed\\] {
    background-color: #fff7ed;
  }
  .bg-\\[\\#fff8ef\\] {
    background-color: #fff8ef;
  }
  .bg-\\[\\#fff9ee\\] {
    background-color: #fff9ee;
  }
  .bg-\\[\\#fffbeb\\] {
    background-color: #fffbeb;
  }
  .bg-\\[\\#fffbeb\\]\\/60 {
    background-color: color-mix(in oklab, #fffbeb 60%, transparent);
  }
  .bg-\\[\\#fffdf8\\] {
    background-color: #fffdf8;
  }
  .bg-\\[rgba\\(0\\,74\\,198\\,0\\.1\\)\\] {
    background-color: rgba(0,74,198,0.1);
  }
  .bg-\\[rgba\\(0\\,74\\,198\\,0\\.05\\)\\] {
    background-color: rgba(0,74,198,0.05);
  }
  .bg-\\[rgba\\(0\\,106\\,98\\,0\\.1\\)\\] {
    background-color: rgba(0,106,98,0.1);
  }
  .bg-\\[rgba\\(49\\,107\\,243\\,0\\.15\\)\\] {
    background-color: rgba(49,107,243,0.15);
  }
  .bg-\\[rgba\\(79\\,55\\,138\\,0\\.1\\)\\] {
    background-color: rgba(79,55,138,0.1);
  }
  .bg-\\[rgba\\(103\\,80\\,164\\,0\\.1\\)\\] {
    background-color: rgba(103,80,164,0.1);
  }
  .bg-\\[rgba\\(127\\,87\\,0\\,0\\.1\\)\\] {
    background-color: rgba(127,87,0,0.1);
  }
  .bg-\\[rgba\\(133\\,83\\,0\\,0\\.1\\)\\] {
    background-color: rgba(133,83,0,0.1);
  }
  .bg-\\[rgba\\(133\\,83\\,0\\,0\\.3\\)\\] {
    background-color: rgba(133,83,0,0.3);
  }
  .bg-\\[rgba\\(135\\,83\\,0\\,0\\.2\\)\\] {
    background-color: rgba(135,83,0,0.2);
  }
  .bg-\\[rgba\\(135\\,83\\,0\\,0\\.03\\)\\] {
    background-color: rgba(135,83,0,0.03);
  }
  .bg-\\[rgba\\(135\\,83\\,0\\,0\\.4\\)\\] {
    background-color: rgba(135,83,0,0.4);
  }
  .bg-\\[rgba\\(135\\,83\\,0\\,0\\.05\\)\\] {
    background-color: rgba(135,83,0,0.05);
  }
  .bg-\\[rgba\\(135\\,83\\,0\\,0\\.08\\)\\] {
    background-color: rgba(135,83,0,0.08);
  }
  .bg-\\[rgba\\(201\\,167\\,77\\,0\\.1\\)\\] {
    background-color: rgba(201,167,77,0.1);
  }
  .bg-\\[rgba\\(205\\,205\\,205\\,0\\.1\\)\\] {
    background-color: rgba(205,205,205,0.1);
  }
  .bg-\\[rgba\\(218\\,226\\,253\\,0\\.4\\)\\] {
    background-color: rgba(218,226,253,0.4);
  }
  .bg-\\[rgba\\(229\\,238\\,255\\,0\\.1\\)\\] {
    background-color: rgba(229,238,255,0.1);
  }
  .bg-\\[rgba\\(239\\,244\\,255\\,0\\.4\\)\\] {
    background-color: rgba(239,244,255,0.4);
  }
  .bg-\\[rgba\\(241\\,149\\,0\\,0\\.1\\)\\] {
    background-color: rgba(241,149,0,0.1);
  }
  .bg-\\[rgba\\(241\\,149\\,0\\,0\\.07\\)\\] {
    background-color: rgba(241,149,0,0.07);
  }
  .bg-\\[rgba\\(242\\,244\\,246\\,0\\.5\\)\\] {
    background-color: rgba(242,244,246,0.5);
  }
  .bg-\\[rgba\\(249\\,115\\,22\\,0\\.1\\)\\] {
    background-color: rgba(249,115,22,0.1);
  }
  .bg-\\[rgba\\(254\\,166\\,25\\,0\\.2\\)\\] {
    background-color: rgba(254,166,25,0.2);
  }
  .bg-\\[rgba\\(255\\,218\\,214\\,0\\.1\\)\\] {
    background-color: rgba(255,218,214,0.1);
  }
  .bg-\\[rgba\\(255\\,218\\,214\\,0\\.2\\)\\] {
    background-color: rgba(255,218,214,0.2);
  }
  .bg-\\[rgba\\(255\\,219\\,202\\,0\\.3\\)\\] {
    background-color: rgba(255,219,202,0.3);
  }
  .bg-\\[rgba\\(255\\,255\\,255\\,0\\.1\\)\\] {
    background-color: rgba(255,255,255,0.1);
  }
  .bg-\\[rgba\\(255\\,255\\,255\\,0\\.5\\)\\] {
    background-color: rgba(255,255,255,0.5);
  }
  .bg-amber-50 {
    background-color: var(--color-amber-50);
  }
  .bg-black {
    background-color: var(--color-black);
  }
  .bg-black\\/10 {
    background-color: color-mix(in srgb, #000 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 10%, transparent);
    }
  }
  .bg-black\\/50 {
    background-color: color-mix(in srgb, #000 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 50%, transparent);
    }
  }
  .bg-black\\/74 {
    background-color: color-mix(in srgb, #000 74%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 74%, transparent);
    }
  }
  .bg-green-50 {
    background-color: var(--color-green-50);
  }
  .bg-green-500 {
    background-color: var(--color-green-500);
  }
  .bg-page-bg {
    background-color: var(--color-page-bg);
  }
  .bg-preview-bg {
    background-color: var(--color-preview-bg);
  }
  .bg-primary {
    background-color: var(--color-primary);
  }
  .bg-primary-soft {
    background-color: var(--color-primary-soft);
  }
  .bg-primary-soft\\/40 {
    background-color: color-mix(in srgb, #fff9ee 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary-soft) 40%, transparent);
    }
  }
  .bg-red-50 {
    background-color: var(--color-red-50);
  }
  .bg-secondary {
    background-color: var(--color-secondary);
  }
  .bg-secondary-soft {
    background-color: var(--color-secondary-soft);
  }
  .bg-sidebar {
    background-color: var(--color-sidebar);
  }
  .bg-slate-50 {
    background-color: var(--color-slate-50);
  }
  .bg-slate-100 {
    background-color: var(--color-slate-100);
  }
  .bg-slate-200 {
    background-color: var(--color-slate-200);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-violet-100 {
    background-color: var(--color-violet-100);
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-white\\/10 {
    background-color: color-mix(in srgb, #fff 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
  }
  .bg-white\\/15 {
    background-color: color-mix(in srgb, #fff 15%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 15%, transparent);
    }
  }
  .bg-white\\/20 {
    background-color: color-mix(in srgb, #fff 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 20%, transparent);
    }
  }
  .bg-white\\/75 {
    background-color: color-mix(in srgb, #fff 75%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 75%, transparent);
    }
  }
  .bg-white\\/80 {
    background-color: color-mix(in srgb, #fff 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 80%, transparent);
    }
  }
  .bg-white\\/90 {
    background-color: color-mix(in srgb, #fff 90%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 90%, transparent);
    }
  }
  .bg-white\\/95 {
    background-color: color-mix(in srgb, #fff 95%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 95%, transparent);
    }
  }
  .bg-gradient-to-br {
    --tw-gradient-position: to bottom right in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-r {
    --tw-gradient-position: to right in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-\\[radial-gradient\\(circle\\,rgba\\(245\\,174\\,51\\,0\\.28\\)_0\\%\\,rgba\\(253\\,228\\,196\\,0\\.16\\)_38\\%\\,rgba\\(255\\,248\\,237\\,0\\.08\\)_58\\%\\,transparent_74\\%\\)\\] {
    background-image: radial-gradient(circle,rgba(245,174,51,0.28) 0%,rgba(253,228,196,0.16) 38%,rgba(255,248,237,0.08) 58%,transparent 74%);
  }
  .from-\\[\\#1e3a5f\\] {
    --tw-gradient-from: #1e3a5f;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-\\[\\#eff4ff\\] {
    --tw-gradient-from: #eff4ff;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-\\[\\#f8ca88\\] {
    --tw-gradient-from: #f8ca88;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-\\[\\#f19500\\] {
    --tw-gradient-from: #f19500;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-\\[\\#fff9ee\\] {
    --tw-gradient-from: #fff9ee;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-white {
    --tw-gradient-from: var(--color-white);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-5\\% {
    --tw-gradient-from-position: 5%;
  }
  .via-\\[\\#875300\\]\\/40 {
    --tw-gradient-via: color-mix(in oklab, #875300 40%, transparent);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-\\[\\#f19500\\]\\/75 {
    --tw-gradient-via: color-mix(in oklab, #f19500 75%, transparent);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-white {
    --tw-gradient-via: var(--color-white);
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-35\\% {
    --tw-gradient-via-position: 35%;
  }
  .to-\\[\\#0f172a\\] {
    --tw-gradient-to: #0f172a;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-\\[\\#eff4ff\\] {
    --tw-gradient-to: #eff4ff;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-\\[\\#f8fafc\\] {
    --tw-gradient-to: #f8fafc;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-\\[rgba\\(140\\,87\\,12\\,0\\)\\] {
    --tw-gradient-to: rgba(140,87,12,0);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-\\[rgba\\(241\\,149\\,0\\,0\\)\\] {
    --tw-gradient-to: rgba(241,149,0,0);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-transparent {
    --tw-gradient-to: transparent;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .bg-clip-padding {
    background-clip: padding-box;
  }
  .fill-\\[\\#7c3aed\\] {
    fill: #7c3aed;
  }
  .fill-\\[\\#16a34a\\] {
    fill: #16a34a;
  }
  .fill-primary {
    fill: var(--color-primary);
  }
  .fill-slate-300 {
    fill: var(--color-slate-300);
  }
  .fill-transparent {
    fill: transparent;
  }
  .fill-white {
    fill: var(--color-white);
  }
  .object-contain {
    object-fit: contain;
  }
  .object-cover {
    object-fit: cover;
  }
  .object-fill {
    object-fit: fill;
  }
  .object-center {
    object-position: center;
  }
  .object-left {
    object-position: left;
  }
  .object-right {
    object-position: right;
  }
  .\\!p-5 {
    padding: var(--spacing-5) !important;
  }
  .p-0 {
    padding: var(--spacing-0);
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: var(--spacing-1);
  }
  .p-1\\.5 {
    padding: calc(var(--spacing) * 1.5);
  }
  .p-2 {
    padding: var(--spacing-2);
  }
  .p-2\\.5 {
    padding: calc(var(--spacing) * 2.5);
  }
  .p-3 {
    padding: var(--spacing-3);
  }
  .p-3\\.5 {
    padding: calc(var(--spacing) * 3.5);
  }
  .p-4 {
    padding: var(--spacing-4);
  }
  .p-5 {
    padding: var(--spacing-5);
  }
  .p-6 {
    padding: var(--spacing-6);
  }
  .p-7 {
    padding: var(--spacing-7);
  }
  .p-8 {
    padding: var(--spacing-8);
  }
  .p-\\[7px\\] {
    padding: 7px;
  }
  .p-\\[9px\\] {
    padding: 9px;
  }
  .p-\\[16px\\] {
    padding: 16px;
  }
  .p-\\[17px\\] {
    padding: 17px;
  }
  .p-\\[18px\\] {
    padding: 18px;
  }
  .p-\\[25px\\] {
    padding: 25px;
  }
  .p-\\[32px\\] {
    padding: 32px;
  }
  .p-card {
    padding: var(--spacing-card);
  }
  .p-card-sm {
    padding: var(--spacing-card-sm);
  }
  .p-px {
    padding: 1px;
  }
  .tema-btn-padding {
    padding-inline: var(--spacing-btn-x);
    padding-block: var(--spacing-btn-y);
  }
  .tema-page-padding {
    padding-inline: var(--spacing-page-x);
    padding-block: var(--spacing-page-y);
  }
  .px-0\\.5 {
    padding-inline: calc(var(--spacing) * 0.5);
  }
  .px-1 {
    padding-inline: var(--spacing-1);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: var(--spacing-2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: var(--spacing-3);
  }
  .px-3\\.5 {
    padding-inline: calc(var(--spacing) * 3.5);
  }
  .px-4 {
    padding-inline: var(--spacing-4);
  }
  .px-5 {
    padding-inline: var(--spacing-5);
  }
  .px-6 {
    padding-inline: var(--spacing-6);
  }
  .px-7 {
    padding-inline: var(--spacing-7);
  }
  .px-8 {
    padding-inline: var(--spacing-8);
  }
  .px-9 {
    padding-inline: calc(var(--spacing) * 9);
  }
  .px-10 {
    padding-inline: var(--spacing-10);
  }
  .px-12 {
    padding-inline: var(--spacing-12);
  }
  .px-16 {
    padding-inline: calc(var(--spacing) * 16);
  }
  .px-\\[8px\\] {
    padding-inline: 8px;
  }
  .px-\\[12px\\] {
    padding-inline: 12px;
  }
  .px-\\[13px\\] {
    padding-inline: 13px;
  }
  .px-\\[15px\\] {
    padding-inline: 15px;
  }
  .px-\\[17px\\] {
    padding-inline: 17px;
  }
  .px-\\[24px\\] {
    padding-inline: 24px;
  }
  .px-card {
    padding-inline: var(--spacing-card);
  }
  .px-card-sm {
    padding-inline: var(--spacing-card-sm);
  }
  .px-page-x {
    padding-inline: var(--spacing-page-x);
  }
  .px-stack-sm {
    padding-inline: var(--spacing-stack-sm);
  }
  .px-toolbar-x {
    padding-inline: var(--spacing-toolbar-x);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: var(--spacing-1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: var(--spacing-2);
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5);
  }
  .py-3 {
    padding-block: var(--spacing-3);
  }
  .py-3\\.5 {
    padding-block: calc(var(--spacing) * 3.5);
  }
  .py-4 {
    padding-block: var(--spacing-4);
  }
  .py-5 {
    padding-block: var(--spacing-5);
  }
  .py-6 {
    padding-block: var(--spacing-6);
  }
  .py-7 {
    padding-block: var(--spacing-7);
  }
  .py-8 {
    padding-block: var(--spacing-8);
  }
  .py-9 {
    padding-block: calc(var(--spacing) * 9);
  }
  .py-10 {
    padding-block: var(--spacing-10);
  }
  .py-12 {
    padding-block: var(--spacing-12);
  }
  .py-16 {
    padding-block: calc(var(--spacing) * 16);
  }
  .py-\\[4px\\] {
    padding-block: 4px;
  }
  .py-\\[7px\\] {
    padding-block: 7px;
  }
  .py-\\[8px\\] {
    padding-block: 8px;
  }
  .py-\\[10px\\] {
    padding-block: 10px;
  }
  .py-\\[13px\\] {
    padding-block: 13px;
  }
  .py-\\[42px\\] {
    padding-block: 42px;
  }
  .py-card-sm {
    padding-block: var(--spacing-card-sm);
  }
  .py-page-y {
    padding-block: var(--spacing-page-y);
  }
  .py-stack-sm {
    padding-block: var(--spacing-stack-sm);
  }
  .pt-0\\.5 {
    padding-top: calc(var(--spacing) * 0.5);
  }
  .pt-1 {
    padding-top: var(--spacing-1);
  }
  .pt-2 {
    padding-top: var(--spacing-2);
  }
  .pt-3 {
    padding-top: var(--spacing-3);
  }
  .pt-4 {
    padding-top: var(--spacing-4);
  }
  .pt-5 {
    padding-top: var(--spacing-5);
  }
  .pt-6 {
    padding-top: var(--spacing-6);
  }
  .pt-8 {
    padding-top: var(--spacing-8);
  }
  .pt-9 {
    padding-top: calc(var(--spacing) * 9);
  }
  .pt-10 {
    padding-top: var(--spacing-10);
  }
  .pt-12 {
    padding-top: var(--spacing-12);
  }
  .pt-\\[8px\\] {
    padding-top: 8px;
  }
  .pt-\\[16px\\] {
    padding-top: 16px;
  }
  .pt-\\[23\\.5px\\] {
    padding-top: 23.5px;
  }
  .pt-\\[33px\\] {
    padding-top: 33px;
  }
  .pt-stack-sm {
    padding-top: var(--spacing-stack-sm);
  }
  .pr-1 {
    padding-right: var(--spacing-1);
  }
  .pr-3 {
    padding-right: var(--spacing-3);
  }
  .pr-5 {
    padding-right: var(--spacing-5);
  }
  .pr-6 {
    padding-right: var(--spacing-6);
  }
  .pr-8 {
    padding-right: var(--spacing-8);
  }
  .pr-10 {
    padding-right: var(--spacing-10);
  }
  .pr-\\[12px\\] {
    padding-right: 12px;
  }
  .pr-\\[88px\\] {
    padding-right: 88px;
  }
  .pr-\\[106\\.5px\\] {
    padding-right: 106.5px;
  }
  .pb-0 {
    padding-bottom: var(--spacing-0);
  }
  .pb-1 {
    padding-bottom: var(--spacing-1);
  }
  .pb-2 {
    padding-bottom: var(--spacing-2);
  }
  .pb-3 {
    padding-bottom: var(--spacing-3);
  }
  .pb-4 {
    padding-bottom: var(--spacing-4);
  }
  .pb-5 {
    padding-bottom: var(--spacing-5);
  }
  .pb-6 {
    padding-bottom: var(--spacing-6);
  }
  .pb-8 {
    padding-bottom: var(--spacing-8);
  }
  .pb-10 {
    padding-bottom: var(--spacing-10);
  }
  .pb-\\[8px\\] {
    padding-bottom: 8px;
  }
  .pb-\\[12px\\] {
    padding-bottom: 12px;
  }
  .pb-\\[75px\\] {
    padding-bottom: 75px;
  }
  .pb-action-bar {
    padding-bottom: var(--spacing-action-bar);
  }
  .pb-card-sm {
    padding-bottom: var(--spacing-card-sm);
  }
  .pl-1 {
    padding-left: var(--spacing-1);
  }
  .pl-2 {
    padding-left: var(--spacing-2);
  }
  .pl-3 {
    padding-left: var(--spacing-3);
  }
  .pl-4 {
    padding-left: var(--spacing-4);
  }
  .pl-5 {
    padding-left: var(--spacing-5);
  }
  .pl-6 {
    padding-left: var(--spacing-6);
  }
  .pl-8 {
    padding-left: var(--spacing-8);
  }
  .pl-10 {
    padding-left: var(--spacing-10);
  }
  .pl-\\[13px\\] {
    padding-left: 13px;
  }
  .pl-\\[18px\\] {
    padding-left: 18px;
  }
  .pl-\\[20px\\] {
    padding-left: 20px;
  }
  .pl-\\[40px\\] {
    padding-left: 40px;
  }
  .pl-\\[89px\\] {
    padding-left: 89px;
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .align-bottom {
    vertical-align: bottom;
  }
  .align-middle {
    vertical-align: middle;
  }
  .align-top {
    vertical-align: top;
  }
  .font-\\[\\'Archivo\\:Regular\\'\\,sans-serif\\] {
    font-family: 'Archivo:Regular',sans-serif;
  }
  .font-\\[\\'DM_Sans\\:Medium\\'\\,sans-serif\\] {
    font-family: 'DM Sans:Medium',sans-serif;
  }
  .font-\\[\\'DM_Sans\\:Regular\\'\\,sans-serif\\] {
    font-family: 'DM Sans:Regular',sans-serif;
  }
  .font-\\[\\'Hanken_Grotesk\\:Medium\\'\\,sans-serif\\] {
    font-family: 'Hanken Grotesk:Medium',sans-serif;
  }
  .font-\\[\\'Hanken_Grotesk\\:SemiBold\\'\\,sans-serif\\] {
    font-family: 'Hanken Grotesk:SemiBold',sans-serif;
  }
  .font-\\[\\'Inter\\:Medium\\'\\,sans-serif\\] {
    font-family: 'Inter:Medium',sans-serif;
  }
  .font-\\[\\'Inter\\:Regular\\'\\,sans-serif\\] {
    font-family: 'Inter:Regular',sans-serif;
  }
  .font-\\[\\'Lato\\:Bold\\'\\,sans-serif\\] {
    font-family: 'Lato:Bold',sans-serif;
  }
  .font-\\[\\'Plus_Jakarta_Sans\\:Medium\\'\\,sans-serif\\] {
    font-family: 'Plus Jakarta Sans:Medium',sans-serif;
  }
  .font-\\[\\'Plus_Jakarta_Sans\\:SemiBold\\'\\,sans-serif\\] {
    font-family: 'Plus Jakarta Sans:SemiBold',sans-serif;
  }
  .font-hanken {
    font-family: var(--font-hanken);
  }
  .font-inter {
    font-family: var(--font-inter);
  }
  .font-jakarta {
    font-family: var(--font-jakarta);
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .font-sans {
    font-family: var(--font-sans);
  }
  .font-serif {
    font-family: var(--font-serif);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-4xl {
    font-size: var(--text-4xl);
    line-height: var(--tw-leading, var(--text-4xl--line-height));
  }
  .text-5xl {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-\\[0\\.92rem\\] {
    font-size: 0.92rem;
  }
  .text-\\[1\\.65rem\\] {
    font-size: 1.65rem;
  }
  .text-\\[8px\\] {
    font-size: 8px;
  }
  .text-\\[9px\\] {
    font-size: 9px;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[12px\\] {
    font-size: 12px;
  }
  .text-\\[13px\\] {
    font-size: 13px;
  }
  .text-\\[14px\\] {
    font-size: 14px;
  }
  .text-\\[15px\\] {
    font-size: 15px;
  }
  .text-\\[16px\\] {
    font-size: 16px;
  }
  .text-\\[18\\.4px\\] {
    font-size: 18.4px;
  }
  .text-\\[18px\\] {
    font-size: 18px;
  }
  .text-\\[20px\\] {
    font-size: 20px;
  }
  .text-\\[22\\.286px\\] {
    font-size: 22.286px;
  }
  .text-\\[24px\\] {
    font-size: 24px;
  }
  .text-\\[25px\\] {
    font-size: 25px;
  }
  .text-\\[26px\\] {
    font-size: 26px;
  }
  .text-\\[28px\\] {
    font-size: 28px;
  }
  .text-\\[32px\\] {
    font-size: 32px;
  }
  .text-\\[36px\\] {
    font-size: 36px;
  }
  .text-\\[40px\\] {
    font-size: 40px;
  }
  .text-\\[48px\\] {
    font-size: 48px;
  }
  .text-\\[49\\.524px\\] {
    font-size: 49.524px;
  }
  .leading-4 {
    --tw-leading: var(--spacing-4);
    line-height: var(--spacing-4);
  }
  .leading-5 {
    --tw-leading: var(--spacing-5);
    line-height: var(--spacing-5);
  }
  .leading-6 {
    --tw-leading: var(--spacing-6);
    line-height: var(--spacing-6);
  }
  .leading-7 {
    --tw-leading: var(--spacing-7);
    line-height: var(--spacing-7);
  }
  .leading-8 {
    --tw-leading: var(--spacing-8);
    line-height: var(--spacing-8);
  }
  .leading-9 {
    --tw-leading: calc(var(--spacing) * 9);
    line-height: calc(var(--spacing) * 9);
  }
  .leading-10 {
    --tw-leading: var(--spacing-10);
    line-height: var(--spacing-10);
  }
  .leading-\\[0\\] {
    --tw-leading: 0;
    line-height: 0;
  }
  .leading-\\[1\\.2\\] {
    --tw-leading: 1.2;
    line-height: 1.2;
  }
  .leading-\\[1\\.6\\] {
    --tw-leading: 1.6;
    line-height: 1.6;
  }
  .leading-\\[1\\.15\\] {
    --tw-leading: 1.15;
    line-height: 1.15;
  }
  .leading-\\[1\\.22\\] {
    --tw-leading: 1.22;
    line-height: 1.22;
  }
  .leading-\\[1\\.45\\] {
    --tw-leading: 1.45;
    line-height: 1.45;
  }
  .leading-\\[15px\\] {
    --tw-leading: 15px;
    line-height: 15px;
  }
  .leading-\\[16px\\] {
    --tw-leading: 16px;
    line-height: 16px;
  }
  .leading-\\[17px\\] {
    --tw-leading: 17px;
    line-height: 17px;
  }
  .leading-\\[18px\\] {
    --tw-leading: 18px;
    line-height: 18px;
  }
  .leading-\\[20px\\] {
    --tw-leading: 20px;
    line-height: 20px;
  }
  .leading-\\[21px\\] {
    --tw-leading: 21px;
    line-height: 21px;
  }
  .leading-\\[22\\.4px\\] {
    --tw-leading: 22.4px;
    line-height: 22.4px;
  }
  .leading-\\[22\\.75px\\] {
    --tw-leading: 22.75px;
    line-height: 22.75px;
  }
  .leading-\\[22px\\] {
    --tw-leading: 22px;
    line-height: 22px;
  }
  .leading-\\[24px\\] {
    --tw-leading: 24px;
    line-height: 24px;
  }
  .leading-\\[26px\\] {
    --tw-leading: 26px;
    line-height: 26px;
  }
  .leading-\\[27px\\] {
    --tw-leading: 27px;
    line-height: 27px;
  }
  .leading-\\[28px\\] {
    --tw-leading: 28px;
    line-height: 28px;
  }
  .leading-\\[29\\.25px\\] {
    --tw-leading: 29.25px;
    line-height: 29.25px;
  }
  .leading-\\[29px\\] {
    --tw-leading: 29px;
    line-height: 29px;
  }
  .leading-\\[30\\.6px\\] {
    --tw-leading: 30.6px;
    line-height: 30.6px;
  }
  .leading-\\[32px\\] {
    --tw-leading: 32px;
    line-height: 32px;
  }
  .leading-\\[34\\.667px\\] {
    --tw-leading: 34.667px;
    line-height: 34.667px;
  }
  .leading-\\[36px\\] {
    --tw-leading: 36px;
    line-height: 36px;
  }
  .leading-\\[44px\\] {
    --tw-leading: 44px;
    line-height: 44px;
  }
  .leading-\\[48px\\] {
    --tw-leading: 48px;
    line-height: 48px;
  }
  .leading-\\[50px\\] {
    --tw-leading: 50px;
    line-height: 50px;
  }
  .leading-\\[52\\.8px\\] {
    --tw-leading: 52.8px;
    line-height: 52.8px;
  }
  .leading-\\[59\\.429px\\] {
    --tw-leading: 59.429px;
    line-height: 59.429px;
  }
  .leading-\\[normal\\] {
    --tw-leading: normal;
    line-height: normal;
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-normal {
    --tw-leading: var(--leading-normal);
    line-height: var(--leading-normal);
  }
  .leading-relaxed {
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
  }
  .leading-snug {
    --tw-leading: var(--leading-snug);
    line-height: var(--leading-snug);
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .font-black {
    --tw-font-weight: var(--font-weight-black);
    font-weight: var(--font-weight-black);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-extrabold {
    --tw-font-weight: var(--font-weight-extrabold);
    font-weight: var(--font-weight-extrabold);
  }
  .font-light {
    --tw-font-weight: var(--font-weight-light);
    font-weight: var(--font-weight-light);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-\\[-0\\.02em\\] {
    --tw-tracking: -0.02em;
    letter-spacing: -0.02em;
  }
  .tracking-\\[-0\\.2px\\] {
    --tw-tracking: -0.2px;
    letter-spacing: -0.2px;
  }
  .tracking-\\[-0\\.3px\\] {
    --tw-tracking: -0.3px;
    letter-spacing: -0.3px;
  }
  .tracking-\\[-0\\.5px\\] {
    --tw-tracking: -0.5px;
    letter-spacing: -0.5px;
  }
  .tracking-\\[-0\\.6px\\] {
    --tw-tracking: -0.6px;
    letter-spacing: -0.6px;
  }
  .tracking-\\[-0\\.7px\\] {
    --tw-tracking: -0.7px;
    letter-spacing: -0.7px;
  }
  .tracking-\\[-0\\.8px\\] {
    --tw-tracking: -0.8px;
    letter-spacing: -0.8px;
  }
  .tracking-\\[-0\\.32px\\] {
    --tw-tracking: -0.32px;
    letter-spacing: -0.32px;
  }
  .tracking-\\[-0\\.64px\\] {
    --tw-tracking: -0.64px;
    letter-spacing: -0.64px;
  }
  .tracking-\\[-0\\.96px\\] {
    --tw-tracking: -0.96px;
    letter-spacing: -0.96px;
  }
  .tracking-\\[-0\\.99px\\] {
    --tw-tracking: -0.99px;
    letter-spacing: -0.99px;
  }
  .tracking-\\[-0\\.9905px\\] {
    --tw-tracking: -0.9905px;
    letter-spacing: -0.9905px;
  }
  .tracking-\\[-1\\.2px\\] {
    --tw-tracking: -1.2px;
    letter-spacing: -1.2px;
  }
  .tracking-\\[-1px\\] {
    --tw-tracking: -1px;
    letter-spacing: -1px;
  }
  .tracking-\\[0\\.1em\\] {
    --tw-tracking: 0.1em;
    letter-spacing: 0.1em;
  }
  .tracking-\\[0\\.04em\\] {
    --tw-tracking: 0.04em;
    letter-spacing: 0.04em;
  }
  .tracking-\\[0\\.5px\\] {
    --tw-tracking: 0.5px;
    letter-spacing: 0.5px;
  }
  .tracking-\\[0\\.06em\\] {
    --tw-tracking: 0.06em;
    letter-spacing: 0.06em;
  }
  .tracking-\\[0\\.6px\\] {
    --tw-tracking: 0.6px;
    letter-spacing: 0.6px;
  }
  .tracking-\\[0\\.7px\\] {
    --tw-tracking: 0.7px;
    letter-spacing: 0.7px;
  }
  .tracking-\\[0\\.08em\\] {
    --tw-tracking: 0.08em;
    letter-spacing: 0.08em;
  }
  .tracking-\\[0\\.8px\\] {
    --tw-tracking: 0.8px;
    letter-spacing: 0.8px;
  }
  .tracking-\\[0\\.12em\\] {
    --tw-tracking: 0.12em;
    letter-spacing: 0.12em;
  }
  .tracking-\\[0\\.12px\\] {
    --tw-tracking: 0.12px;
    letter-spacing: 0.12px;
  }
  .tracking-\\[0\\.14em\\] {
    --tw-tracking: 0.14em;
    letter-spacing: 0.14em;
  }
  .tracking-\\[0\\.16em\\] {
    --tw-tracking: 0.16em;
    letter-spacing: 0.16em;
  }
  .tracking-\\[0\\.18em\\] {
    --tw-tracking: 0.18em;
    letter-spacing: 0.18em;
  }
  .tracking-\\[0\\.22px\\] {
    --tw-tracking: 0.22px;
    letter-spacing: 0.22px;
  }
  .tracking-\\[0\\.55px\\] {
    --tw-tracking: 0.55px;
    letter-spacing: 0.55px;
  }
  .tracking-\\[0\\.65px\\] {
    --tw-tracking: 0.65px;
    letter-spacing: 0.65px;
  }
  .tracking-\\[0\\.82px\\] {
    --tw-tracking: 0.82px;
    letter-spacing: 0.82px;
  }
  .tracking-\\[0\\.91px\\] {
    --tw-tracking: 0.91px;
    letter-spacing: 0.91px;
  }
  .tracking-\\[0\\.325px\\] {
    --tw-tracking: 0.325px;
    letter-spacing: 0.325px;
  }
  .tracking-\\[1\\.1px\\] {
    --tw-tracking: 1.1px;
    letter-spacing: 1.1px;
  }
  .tracking-\\[1\\.2px\\] {
    --tw-tracking: 1.2px;
    letter-spacing: 1.2px;
  }
  .tracking-\\[1\\.4px\\] {
    --tw-tracking: 1.4px;
    letter-spacing: 1.4px;
  }
  .tracking-\\[1\\.5px\\] {
    --tw-tracking: 1.5px;
    letter-spacing: 1.5px;
  }
  .tracking-\\[1px\\] {
    --tw-tracking: 1px;
    letter-spacing: 1px;
  }
  .tracking-\\[2\\.2px\\] {
    --tw-tracking: 2.2px;
    letter-spacing: 2.2px;
  }
  .tracking-\\[2px\\] {
    --tw-tracking: 2px;
    letter-spacing: 2px;
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .tracking-widest {
    --tw-tracking: var(--tracking-widest);
    letter-spacing: var(--tracking-widest);
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .\\[word-break\\:break-word\\] {
    word-break: break-word;
  }
  .break-all {
    word-break: break-all;
  }
  .whitespace-normal {
    white-space: normal;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .whitespace-pre-line {
    white-space: pre-line;
  }
  .whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .\\!text-\\[\\#777777\\] {
    color: #777777 !important;
  }
  .text-\\[\\#0b1c30\\] {
    color: #0b1c30;
  }
  .text-\\[\\#0b8447\\] {
    color: #0b8447;
  }
  .text-\\[\\#0f172a\\] {
    color: #0f172a;
  }
  .text-\\[\\#1B1B2F\\] {
    color: #1B1B2F;
  }
  .text-\\[\\#1b1b2f\\] {
    color: #1b1b2f;
  }
  .text-\\[\\#1d1b20\\] {
    color: #1d1b20;
  }
  .text-\\[\\#1d4ed8\\] {
    color: #1d4ed8;
  }
  .text-\\[\\#1e3a5f\\] {
    color: #1e3a5f;
  }
  .text-\\[\\#1e3a8a\\] {
    color: #1e3a8a;
  }
  .text-\\[\\#1e40af\\] {
    color: #1e40af;
  }
  .text-\\[\\#1f2937\\] {
    color: #1f2937;
  }
  .text-\\[\\#004ac6\\] {
    color: #004ac6;
  }
  .text-\\[\\#4c1d95\\] {
    color: #4c1d95;
  }
  .text-\\[\\#4f378a\\] {
    color: #4f378a;
  }
  .text-\\[\\#5b21b6\\] {
    color: #5b21b6;
  }
  .text-\\[\\#006a62\\] {
    color: #006a62;
  }
  .text-\\[\\#6B7280\\] {
    color: #6B7280;
  }
  .text-\\[\\#6b21a8\\] {
    color: #6b21a8;
  }
  .text-\\[\\#6b7280\\] {
    color: #6b7280;
  }
  .text-\\[\\#6d28d9\\] {
    color: #6d28d9;
  }
  .text-\\[\\#6ec895\\] {
    color: #6ec895;
  }
  .text-\\[\\#7a3a00\\] {
    color: #7a3a00;
  }
  .text-\\[\\#7c3aed\\] {
    color: #7c3aed;
  }
  .text-\\[\\#7c8596\\] {
    color: #7c8596;
  }
  .text-\\[\\#7d8797\\] {
    color: #7d8797;
  }
  .text-\\[\\#7f1d1d\\] {
    color: #7f1d1d;
  }
  .text-\\[\\#8b95a7\\] {
    color: #8b95a7;
  }
  .text-\\[\\#8d9aae\\] {
    color: #8d9aae;
  }
  .text-\\[\\#9CA3AF\\] {
    color: #9CA3AF;
  }
  .text-\\[\\#9a3412\\] {
    color: #9a3412;
  }
  .text-\\[\\#9ca3af\\] {
    color: #9ca3af;
  }
  .text-\\[\\#9d174d\\] {
    color: #9d174d;
  }
  .text-\\[\\#9d4300\\] {
    color: #9d4300;
  }
  .text-\\[\\#16a34a\\] {
    color: #16a34a;
  }
  .text-\\[\\#20a466\\] {
    color: #20a466;
  }
  .text-\\[\\#94a3b8\\] {
    color: #94a3b8;
  }
  .text-\\[\\#00174b\\] {
    color: #00174b;
  }
  .text-\\[\\#181c23\\] {
    color: #181c23;
  }
  .text-\\[\\#191b23\\] {
    color: #191b23;
  }
  .text-\\[\\#191c1e\\] {
    color: #191c1e;
  }
  .text-\\[\\#00311f\\] {
    color: #00311f;
  }
  .text-\\[\\#765b00\\] {
    color: #765b00;
  }
  .text-\\[\\#765b00\\]\\/10 {
    color: color-mix(in oklab, #765b00 10%, transparent);
  }
  .text-\\[\\#777\\] {
    color: #777;
  }
  .text-\\[\\#991b1b\\] {
    color: #991b1b;
  }
  .text-\\[\\#2563eb\\] {
    color: #2563eb;
  }
  .text-\\[\\#005792\\] {
    color: #005792;
  }
  .text-\\[\\#8064f6\\] {
    color: #8064f6;
  }
  .text-\\[\\#9333ea\\] {
    color: #9333ea;
  }
  .text-\\[\\#10203a\\] {
    color: #10203a;
  }
  .text-\\[\\#15803d\\] {
    color: #15803d;
  }
  .text-\\[\\#020202\\] {
    color: #020202;
  }
  .text-\\[\\#38485d\\] {
    color: #38485d;
  }
  .text-\\[\\#49454f\\] {
    color: #49454f;
  }
  .text-\\[\\#57534e\\] {
    color: #57534e;
  }
  .text-\\[\\#059669\\] {
    color: #059669;
  }
  .text-\\[\\#63597c\\] {
    color: #63597c;
  }
  .text-\\[\\#64748b\\] {
    color: #64748b;
  }
  .text-\\[\\#78350f\\] {
    color: #78350f;
  }
  .text-\\[\\#78716c\\] {
    color: #78716c;
  }
  .text-\\[\\#085891\\] {
    color: #085891;
  }
  .text-\\[\\#091426\\] {
    color: #091426;
  }
  .text-\\[\\#92400e\\] {
    color: #92400e;
  }
  .text-\\[\\#101010\\] {
    color: #101010;
  }
  .text-\\[\\#101828\\] {
    color: #101828;
  }
  .text-\\[\\#111827\\] {
    color: #111827;
  }
  .text-\\[\\#166534\\] {
    color: #166534;
  }
  .text-\\[\\#172033\\] {
    color: #172033;
  }
  .text-\\[\\#263247\\] {
    color: #263247;
  }
  .text-\\[\\#292524\\] {
    color: #292524;
  }
  .text-\\[\\#334155\\] {
    color: #334155;
  }
  .text-\\[\\#353535\\] {
    color: #353535;
  }
  .text-\\[\\#363636\\] {
    color: #363636;
  }
  .text-\\[\\#374151\\] {
    color: #374151;
  }
  .text-\\[\\#404754\\] {
    color: #404754;
  }
  .text-\\[\\#431407\\] {
    color: #431407;
  }
  .text-\\[\\#434654\\] {
    color: #434654;
  }
  .text-\\[\\#434655\\] {
    color: #434655;
  }
  .text-\\[\\#434655\\]\\/80 {
    color: color-mix(in oklab, #434655 80%, transparent);
  }
  .text-\\[\\#444651\\] {
    color: #444651;
  }
  .text-\\[\\#475569\\] {
    color: #475569;
  }
  .text-\\[\\#494551\\] {
    color: #494551;
  }
  .text-\\[\\#525252\\] {
    color: #525252;
  }
  .text-\\[\\#525252\\]\\/80 {
    color: color-mix(in oklab, #525252 80%, transparent);
  }
  .text-\\[\\#566174\\] {
    color: #566174;
  }
  .text-\\[\\#582200\\] {
    color: #582200;
  }
  .text-\\[\\#584237\\] {
    color: #584237;
  }
  .text-\\[\\#684000\\] {
    color: #684000;
  }
  .text-\\[\\#687386\\] {
    color: #687386;
  }
  .text-\\[\\#717182\\] {
    color: #717182;
  }
  .text-\\[\\#718096\\] {
    color: #718096;
  }
  .text-\\[\\#757682\\] {
    color: #757682;
  }
  .text-\\[\\#773200\\] {
    color: #773200;
  }
  .text-\\[\\#831843\\] {
    color: #831843;
  }
  .text-\\[\\#875300\\] {
    color: #875300;
  }
  .text-\\[\\#a0abbb\\] {
    color: #a0abbb;
  }
  .text-\\[\\#a86f00\\] {
    color: #a86f00;
  }
  .text-\\[\\#b91c1c\\] {
    color: #b91c1c;
  }
  .text-\\[\\#b42318\\] {
    color: #b42318;
  }
  .text-\\[\\#b45309\\] {
    color: #b45309;
  }
  .text-\\[\\#b54708\\] {
    color: #b54708;
  }
  .text-\\[\\#b87300\\] {
    color: #b87300;
  }
  .text-\\[\\#ba1a1a\\] {
    color: #ba1a1a;
  }
  .text-\\[\\#be185d\\] {
    color: #be185d;
  }
  .text-\\[\\#c5c5d3\\] {
    color: #c5c5d3;
  }
  .text-\\[\\#cbd5e1\\] {
    color: #cbd5e1;
  }
  .text-\\[\\#db2777\\] {
    color: #db2777;
  }
  .text-\\[\\#dc2626\\] {
    color: #dc2626;
  }
  .text-\\[\\#f08a00\\] {
    color: #f08a00;
  }
  .text-\\[\\#f9a203\\] {
    color: #f9a203;
  }
  .text-\\[\\#f19500\\] {
    color: #f19500;
  }
  .text-\\[\\#f97316\\] {
    color: #f97316;
  }
  .text-\\[\\#fcd34d\\] {
    color: #fcd34d;
  }
  .text-\\[rgba\\(69\\,71\\,76\\,0\\.7\\)\\] {
    color: rgba(69,71,76,0.7);
  }
  .text-\\[rgba\\(69\\,71\\,76\\,0\\.45\\)\\] {
    color: rgba(69,71,76,0.45);
  }
  .text-\\[rgba\\(69\\,71\\,76\\,0\\.55\\)\\] {
    color: rgba(69,71,76,0.55);
  }
  .text-\\[rgba\\(69\\,71\\,76\\,0\\.65\\)\\] {
    color: rgba(69,71,76,0.65);
  }
  .text-\\[rgba\\(69\\,71\\,76\\,0\\.75\\)\\] {
    color: rgba(69,71,76,0.75);
  }
  .text-\\[rgba\\(135\\,83\\,0\\,0\\.6\\)\\] {
    color: rgba(135,83,0,0.6);
  }
  .text-amber-700 {
    color: var(--color-amber-700);
  }
  .text-amber-800 {
    color: var(--color-amber-800);
  }
  .text-amber-900 {
    color: var(--color-amber-900);
  }
  .text-black {
    color: var(--color-black);
  }
  .text-black\\/50 {
    color: color-mix(in srgb, #000 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-black) 50%, transparent);
    }
  }
  .text-black\\/60 {
    color: color-mix(in srgb, #000 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-black) 60%, transparent);
    }
  }
  .text-black\\/80 {
    color: color-mix(in srgb, #000 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-black) 80%, transparent);
    }
  }
  .text-blue-200 {
    color: var(--color-blue-200);
  }
  .text-blue-300 {
    color: var(--color-blue-300);
  }
  .text-blue-600 {
    color: var(--color-blue-600);
  }
  .text-green-100 {
    color: var(--color-green-100);
  }
  .text-green-300 {
    color: var(--color-green-300);
  }
  .text-green-400 {
    color: var(--color-green-400);
  }
  .text-green-500 {
    color: var(--color-green-500);
  }
  .text-green-600 {
    color: var(--color-green-600);
  }
  .text-green-700 {
    color: var(--color-green-700);
  }
  .text-green-800 {
    color: var(--color-green-800);
  }
  .text-inherit {
    color: inherit;
  }
  .text-orange-100 {
    color: var(--color-orange-100);
  }
  .text-preview {
    color: var(--color-preview);
  }
  .text-primary {
    color: var(--color-primary);
  }
  .text-primary\\/60 {
    color: color-mix(in srgb, #f19500 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-primary) 60%, transparent);
    }
  }
  .text-purple-200 {
    color: var(--color-purple-200);
  }
  .text-red-400 {
    color: var(--color-red-400);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-red-700 {
    color: var(--color-red-700);
  }
  .text-red-800 {
    color: var(--color-red-800);
  }
  .text-rose-700 {
    color: var(--color-rose-700);
  }
  .text-rose-800 {
    color: var(--color-rose-800);
  }
  .text-secondary {
    color: var(--color-secondary);
  }
  .text-secondary\\/60 {
    color: color-mix(in srgb, #009dff 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-secondary) 60%, transparent);
    }
  }
  .text-slate-200 {
    color: var(--color-slate-200);
  }
  .text-slate-300 {
    color: var(--color-slate-300);
  }
  .text-slate-400 {
    color: var(--color-slate-400);
  }
  .text-slate-500 {
    color: var(--color-slate-500);
  }
  .text-slate-600 {
    color: var(--color-slate-600);
  }
  .text-slate-700 {
    color: var(--color-slate-700);
  }
  .text-slate-800 {
    color: var(--color-slate-800);
  }
  .text-text-primary {
    color: var(--color-text-primary);
  }
  .text-text-secondary {
    color: var(--color-text-secondary);
  }
  .text-violet-700 {
    color: var(--color-violet-700);
  }
  .text-white {
    color: var(--color-white);
  }
  .text-white\\/70 {
    color: color-mix(in srgb, #fff 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 70%, transparent);
    }
  }
  .text-white\\/75 {
    color: color-mix(in srgb, #fff 75%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 75%, transparent);
    }
  }
  .text-white\\/80 {
    color: color-mix(in srgb, #fff 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 80%, transparent);
    }
  }
  .text-white\\/90 {
    color: color-mix(in srgb, #fff 90%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 90%, transparent);
    }
  }
  .text-white\\/95 {
    color: color-mix(in srgb, #fff 95%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 95%, transparent);
    }
  }
  .lowercase {
    text-transform: lowercase;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .not-italic {
    font-style: normal;
  }
  .tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .line-through {
    text-decoration-line: line-through;
  }
  .underline {
    text-decoration-line: underline;
  }
  .accent-\\[\\#f28a00\\] {
    accent-color: #f28a00;
  }
  .accent-primary {
    accent-color: var(--color-primary);
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-5 {
    opacity: 5%;
  }
  .opacity-10 {
    opacity: 10%;
  }
  .opacity-20 {
    opacity: 20%;
  }
  .opacity-40 {
    opacity: 40%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-70 {
    opacity: 70%;
  }
  .opacity-80 {
    opacity: 80%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .opacity-\\[0\\.05\\] {
    opacity: 0.05;
  }
  .opacity-\\[0\\.07\\] {
    opacity: 0.07;
  }
  .opacity-\\[0\\.08\\] {
    opacity: 0.08;
  }
  .mix-blend-multiply {
    mix-blend-mode: multiply;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[-8px_0px_24px_0px_rgba\\(15\\,23\\,42\\,0\\.14\\)\\] {
    --tw-shadow: -8px 0px 24px 0px var(--tw-shadow-color, rgba(15,23,42,0.14));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_-4px_24px_rgba\\(15\\,23\\,42\\,0\\.08\\)\\] {
    --tw-shadow: 0 -4px 24px var(--tw-shadow-color, rgba(15,23,42,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_-8px_24px_rgba\\(15\\,23\\,42\\,0\\.08\\)\\] {
    --tw-shadow: 0 -8px 24px var(--tw-shadow-color, rgba(15,23,42,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_0_0_1px_\\#f97316\\] {
    --tw-shadow: 0 0 0 1px var(--tw-shadow-color, #f97316);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_0_0_1px_rgba\\(15\\,23\\,42\\,0\\.04\\)\\] {
    --tw-shadow: 0 0 0 1px var(--tw-shadow-color, rgba(15,23,42,0.04));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_2px_8px_rgba\\(15\\,23\\,42\\,0\\.04\\)\\] {
    --tw-shadow: 0 2px 8px var(--tw-shadow-color, rgba(15,23,42,0.04));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_8px_24px_rgba\\(15\\,23\\,42\\,0\\.12\\)\\] {
    --tw-shadow: 0 8px 24px var(--tw-shadow-color, rgba(15,23,42,0.12));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_8px_30px_rgba\\(15\\,23\\,42\\,0\\.08\\)\\] {
    --tw-shadow: 0 8px 30px var(--tw-shadow-color, rgba(15,23,42,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_12px_32px_rgba\\(15\\,23\\,42\\,0\\.12\\)\\] {
    --tw-shadow: 0 12px 32px var(--tw-shadow-color, rgba(15,23,42,0.12));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_12px_40px_rgba\\(0\\,0\\,0\\,0\\.18\\)\\] {
    --tw-shadow: 0 12px 40px var(--tw-shadow-color, rgba(0,0,0,0.18));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_24px_48px_rgba\\(15\\,23\\,42\\,0\\.18\\)\\] {
    --tw-shadow: 0 24px 48px var(--tw-shadow-color, rgba(15,23,42,0.18));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_0px_0px_4px_rgba\\(37\\,99\\,235\\,0\\.12\\)\\] {
    --tw-shadow: 0px 0px 0px 4px var(--tw-shadow-color, rgba(37,99,235,0.12));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_1\\.5px_rgba\\(0\\,0\\,0\\,0\\.1\\)\\] {
    --tw-shadow: 0px 1px 1.5px var(--tw-shadow-color, rgba(0,0,0,0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_1\\.5px_rgba\\(0\\,0\\,0\\,0\\.05\\)\\] {
    --tw-shadow: 0px 1px 1.5px var(--tw-shadow-color, rgba(0,0,0,0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_1\\.5px_rgba\\(0\\,0\\,0\\,0\\.06\\)\\] {
    --tw-shadow: 0px 1px 1.5px var(--tw-shadow-color, rgba(0,0,0,0.06));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_1px_rgba\\(0\\,0\\,0\\,0\\.04\\)\\] {
    --tw-shadow: 0px 1px 1px var(--tw-shadow-color, rgba(0,0,0,0.04));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_1px_rgba\\(0\\,0\\,0\\,0\\.05\\)\\] {
    --tw-shadow: 0px 1px 1px var(--tw-shadow-color, rgba(0,0,0,0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_2px_rgba\\(0\\,0\\,0\\,0\\.04\\)\\] {
    --tw-shadow: 0px 1px 2px var(--tw-shadow-color, rgba(0,0,0,0.04));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_2px_rgba\\(0\\,0\\,0\\,0\\.05\\)\\] {
    --tw-shadow: 0px 1px 2px var(--tw-shadow-color, rgba(0,0,0,0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_2px_rgba\\(15\\,23\\,42\\,0\\.06\\)\\] {
    --tw-shadow: 0px 1px 2px var(--tw-shadow-color, rgba(15,23,42,0.06));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_3px_rgba\\(0\\,0\\,0\\,0\\.04\\)\\] {
    --tw-shadow: 0px 1px 3px var(--tw-shadow-color, rgba(0,0,0,0.04));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_3px_rgba\\(0\\,0\\,0\\,0\\.06\\)\\] {
    --tw-shadow: 0px 1px 3px var(--tw-shadow-color, rgba(0,0,0,0.06));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_3px_rgba\\(15\\,23\\,42\\,0\\.06\\)\\] {
    --tw-shadow: 0px 1px 3px var(--tw-shadow-color, rgba(15,23,42,0.06));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_2px_8px_rgba\\(241\\,149\\,0\\,0\\.08\\)\\] {
    --tw-shadow: 0px 2px 8px var(--tw-shadow-color, rgba(241,149,0,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_2px_8px_rgba\\(242\\,101\\,34\\,0\\.35\\)\\] {
    --tw-shadow: 0px 2px 8px var(--tw-shadow-color, rgba(242,101,34,0.35));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_4px_0px_rgba\\(0\\,0\\,0\\,0\\.07\\)\\] {
    --tw-shadow: 0px 4px 4px 0px var(--tw-shadow-color, rgba(0,0,0,0.07));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_6px_-1px_rgba\\(0\\,0\\,0\\,0\\.1\\)\\] {
    --tw-shadow: 0px 4px 6px -1px var(--tw-shadow-color, rgba(0,0,0,0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_6px_-1px_rgba\\(135\\,83\\,0\\,0\\.2\\)\\,0px_2px_4px_-2px_rgba\\(135\\,83\\,0\\,0\\.2\\)\\] {
    --tw-shadow: 0px 4px 6px -1px var(--tw-shadow-color, rgba(135,83,0,0.2)), 0px 2px 4px -2px var(--tw-shadow-color, rgba(135,83,0,0.2));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_10px_rgba\\(0\\,157\\,255\\,0\\.18\\)\\] {
    --tw-shadow: 0px 4px 10px var(--tw-shadow-color, rgba(0,157,255,0.18));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_10px_rgba\\(103\\,80\\,164\\,0\\.06\\)\\] {
    --tw-shadow: 0px 4px 10px var(--tw-shadow-color, rgba(103,80,164,0.06));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_12px_rgba\\(241\\,149\\,0\\,0\\.2\\)\\] {
    --tw-shadow: 0px 4px 12px var(--tw-shadow-color, rgba(241,149,0,0.2));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_14px_rgba\\(0\\,87\\,153\\,0\\.28\\)\\] {
    --tw-shadow: 0px 4px 14px var(--tw-shadow-color, rgba(0,87,153,0.28));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_16px_rgba\\(15\\,23\\,42\\,0\\.04\\)\\] {
    --tw-shadow: 0px 4px 16px var(--tw-shadow-color, rgba(15,23,42,0.04));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_16px_rgba\\(241\\,149\\,0\\,0\\.1\\)\\] {
    --tw-shadow: 0px 4px 16px var(--tw-shadow-color, rgba(241,149,0,0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_16px_rgba\\(241\\,149\\,0\\,0\\.06\\)\\] {
    --tw-shadow: 0px 4px 16px var(--tw-shadow-color, rgba(241,149,0,0.06));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_20px_-2px_rgba\\(0\\,0\\,0\\,0\\.05\\)\\,0px_2px_8px_-2px_rgba\\(0\\,0\\,0\\,0\\.03\\)\\] {
    --tw-shadow: 0px 4px 20px -2px var(--tw-shadow-color, rgba(0,0,0,0.05)), 0px 2px 8px -2px var(--tw-shadow-color, rgba(0,0,0,0.03));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_20px_-2px_rgba\\(0\\,0\\,0\\,0\\.05\\)\\] {
    --tw-shadow: 0px 4px 20px -2px var(--tw-shadow-color, rgba(0,0,0,0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_20px_rgba\\(103\\,80\\,164\\,0\\.06\\)\\] {
    --tw-shadow: 0px 4px 20px var(--tw-shadow-color, rgba(103,80,164,0.06));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_6px_18px_0px_rgba\\(16\\,32\\,58\\,0\\.04\\)\\] {
    --tw-shadow: 0px 6px 18px 0px var(--tw-shadow-color, rgba(16,32,58,0.04));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_6px_20px_rgba\\(242\\,101\\,34\\,0\\.28\\)\\] {
    --tw-shadow: 0px 6px 20px var(--tw-shadow-color, rgba(242,101,34,0.28));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_8px_12px_rgba\\(129\\,160\\,237\\,0\\.3\\)\\] {
    --tw-shadow: 0px 8px 12px var(--tw-shadow-color, rgba(129,160,237,0.3));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_8px_12px_rgba\\(245\\,158\\,11\\,0\\.3\\)\\] {
    --tw-shadow: 0px 8px 12px var(--tw-shadow-color, rgba(245,158,11,0.3));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_8px_20px_rgba\\(241\\,149\\,0\\,0\\.15\\)\\] {
    --tw-shadow: 0px 8px 20px var(--tw-shadow-color, rgba(241,149,0,0.15));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_8px_24px_-12px_rgba\\(0\\,102\\,255\\,0\\.4\\)\\] {
    --tw-shadow: 0px 8px 24px -12px var(--tw-shadow-color, rgba(0,102,255,0.4));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_8px_24px_-12px_rgba\\(135\\,83\\,0\\,0\\.4\\)\\] {
    --tw-shadow: 0px 8px 24px -12px var(--tw-shadow-color, rgba(135,83,0,0.4));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_8px_24px_0px_rgba\\(15\\,23\\,42\\,0\\.14\\)\\] {
    --tw-shadow: 0px 8px 24px 0px var(--tw-shadow-color, rgba(15,23,42,0.14));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_8px_24px_0px_rgba\\(245\\,158\\,11\\,0\\.3\\)\\] {
    --tw-shadow: 0px 8px 24px 0px var(--tw-shadow-color, rgba(245,158,11,0.3));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_8px_24px_rgba\\(15\\,23\\,42\\,0\\.12\\)\\] {
    --tw-shadow: 0px 8px 24px var(--tw-shadow-color, rgba(15,23,42,0.12));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_8px_24px_rgba\\(245\\,158\\,11\\,0\\.3\\)\\] {
    --tw-shadow: 0px 8px 24px var(--tw-shadow-color, rgba(245,158,11,0.3));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_8px_30px_rgba\\(241\\,149\\,0\\,0\\.08\\)\\] {
    --tw-shadow: 0px 8px 30px var(--tw-shadow-color, rgba(241,149,0,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_10px_15px_-3px_rgba\\(0\\,0\\,0\\,0\\.1\\)\\,0px_4px_6px_-4px_rgba\\(0\\,0\\,0\\,0\\.1\\)\\] {
    --tw-shadow: 0px 10px 15px -3px var(--tw-shadow-color, rgba(0,0,0,0.1)), 0px 4px 6px -4px var(--tw-shadow-color, rgba(0,0,0,0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_12px_30px_-12px_rgba\\(135\\,83\\,0\\,0\\.5\\)\\] {
    --tw-shadow: 0px 12px 30px -12px var(--tw-shadow-color, rgba(135,83,0,0.5));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_12px_30px_0px_rgba\\(15\\,23\\,42\\,0\\.14\\)\\] {
    --tw-shadow: 0px 12px 30px 0px var(--tw-shadow-color, rgba(15,23,42,0.14));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_12px_40px_-12px_rgba\\(0\\,0\\,0\\,0\\.08\\)\\] {
    --tw-shadow: 0px 12px 40px -12px var(--tw-shadow-color, rgba(0,0,0,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_12px_40px_-12px_rgba\\(0\\,0\\,0\\,0\\.25\\)\\] {
    --tw-shadow: 0px 12px 40px -12px var(--tw-shadow-color, rgba(0,0,0,0.25));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_16px_40px_rgba\\(15\\,23\\,42\\,0\\.16\\)\\] {
    --tw-shadow: 0px 16px 40px var(--tw-shadow-color, rgba(15,23,42,0.16));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[inset_0px_2px_4px_0px_rgba\\(0\\,0\\,0\\,0\\.05\\)\\] {
    --tw-shadow: inset 0px 2px 4px 0px var(--tw-shadow-color, rgba(0,0,0,0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-none {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-0 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-1 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-\\[\\#bbf7d0\\] {
    --tw-ring-color: #bbf7d0;
  }
  .ring-\\[\\#ddd6fe\\] {
    --tw-ring-color: #ddd6fe;
  }
  .ring-\\[\\#ef4444\\]\\/40 {
    --tw-ring-color: color-mix(in oklab, #ef4444 40%, transparent);
  }
  .ring-\\[\\#fda29b\\] {
    --tw-ring-color: #fda29b;
  }
  .ring-\\[\\#fde4c4\\] {
    --tw-ring-color: #fde4c4;
  }
  .ring-primary {
    --tw-ring-color: var(--color-primary);
  }
  .ring-primary\\/30 {
    --tw-ring-color: color-mix(in srgb, #f19500 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-primary) 30%, transparent);
    }
  }
  .ring-secondary\\/30 {
    --tw-ring-color: color-mix(in srgb, #009dff 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-secondary) 30%, transparent);
    }
  }
  .ring-sidebar {
    --tw-ring-color: var(--color-sidebar);
  }
  .ring-white {
    --tw-ring-color: var(--color-white);
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .blur-2xl {
    --tw-blur: blur(var(--blur-2xl));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .blur-3xl {
    --tw-blur: blur(var(--blur-3xl));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .blur-\\[32px\\] {
    --tw-blur: blur(32px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow-\\[0px_1px_1px_rgba\\(0\\,0\\,0\\,0\\.05\\)\\] {
    --tw-drop-shadow-size: drop-shadow(0px 1px 1px var(--tw-drop-shadow-color, rgba(0,0,0,0.05)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow-\\[0px_4px_2px_rgba\\(0\\,0\\,0\\,0\\.06\\)\\] {
    --tw-drop-shadow-size: drop-shadow(0px 4px 2px var(--tw-drop-shadow-color, rgba(0,0,0,0.06)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow-\\[0px_4px_3px_rgba\\(0\\,0\\,0\\,0\\.1\\)\\,0px_2px_2px_rgba\\(0\\,0\\,0\\,0\\.1\\)\\] {
    --tw-drop-shadow-size: drop-shadow(0px 4px 3px var(--tw-drop-shadow-color, rgba(0,0,0,0.1))) drop-shadow(0px 2px 2px var(--tw-drop-shadow-color, rgba(0,0,0,0.1)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow-\\[4px_3px_3\\.3px_rgba\\(0\\,0\\,0\\,0\\.08\\)\\] {
    --tw-drop-shadow-size: drop-shadow(4px 3px 3.3px var(--tw-drop-shadow-color, rgba(0,0,0,0.08)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur-\\[1px\\] {
    --tw-backdrop-blur: blur(1px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-blur-\\[2px\\] {
    --tw-backdrop-blur: blur(2px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(var(--blur-sm));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[border-color\\,box-shadow\\] {
    transition-property: border-color,box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[width\\,transform\\] {
    transition-property: width,transform;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-150 {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-400 {
    --tw-duration: 400ms;
    transition-duration: 400ms;
  }
  .duration-500 {
    --tw-duration: 500ms;
    transition-duration: 500ms;
  }
  .duration-700 {
    --tw-duration: 700ms;
    transition-duration: 700ms;
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .ring-inset {
    --tw-ring-inset: inset;
  }
  .group-focus-within\\/info\\:block {
    &:is(:where(.group\\/info):focus-within *) {
      display: block;
    }
  }
  .group-hover\\:gap-3 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        gap: var(--spacing-3);
      }
    }
  }
  .group-hover\\:border-\\[\\#cbd5e1\\] {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        border-color: #cbd5e1;
      }
    }
  }
  .group-hover\\:bg-primary-hover {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        background-color: var(--color-primary-hover);
      }
    }
  }
  .group-hover\\:text-primary {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-primary);
      }
    }
  }
  .group-hover\\:text-primary-hover {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-primary-hover);
      }
    }
  }
  .group-hover\\:opacity-100 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .group-hover\\/info\\:block {
    &:is(:where(.group\\/info):hover *) {
      @media (hover: hover) {
        display: block;
      }
    }
  }
  .placeholder\\:font-semibold {
    &::placeholder {
      --tw-font-weight: var(--font-weight-semibold);
      font-weight: var(--font-weight-semibold);
    }
  }
  .placeholder\\:text-\\[\\#6b7280\\] {
    &::placeholder {
      color: #6b7280;
    }
  }
  .placeholder\\:text-\\[\\#9ca3af\\] {
    &::placeholder {
      color: #9ca3af;
    }
  }
  .placeholder\\:text-\\[\\#94a3b8\\] {
    &::placeholder {
      color: #94a3b8;
    }
  }
  .placeholder\\:text-\\[\\#181c23\\]\\/40 {
    &::placeholder {
      color: color-mix(in oklab, #181c23 40%, transparent);
    }
  }
  .placeholder\\:text-\\[\\#717182\\] {
    &::placeholder {
      color: #717182;
    }
  }
  .placeholder\\:text-\\[\\#757682\\] {
    &::placeholder {
      color: #757682;
    }
  }
  .placeholder\\:text-\\[\\#cbd5e1\\] {
    &::placeholder {
      color: #cbd5e1;
    }
  }
  .placeholder\\:text-\\[rgba\\(69\\,71\\,76\\,0\\.45\\)\\] {
    &::placeholder {
      color: rgba(69,71,76,0.45);
    }
  }
  .last\\:mb-0 {
    &:last-child {
      margin-bottom: var(--spacing-0);
    }
  }
  .last\\:border-0 {
    &:last-child {
      border-style: var(--tw-border-style);
      border-width: 0px;
    }
  }
  .last\\:border-b-0 {
    &:last-child {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 0px;
    }
  }
  .last\\:pb-0 {
    &:last-child {
      padding-bottom: var(--spacing-0);
    }
  }
  .focus-within\\:border-secondary {
    &:focus-within {
      border-color: var(--color-secondary);
    }
  }
  .focus-within\\:ring-2 {
    &:focus-within {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-within\\:ring-secondary\\/30 {
    &:focus-within {
      --tw-ring-color: color-mix(in srgb, #009dff 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-secondary) 30%, transparent);
      }
    }
  }
  .focus-within\\:outline-none {
    &:focus-within {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .hover\\:border-\\[\\#94a3b8\\] {
    &:hover {
      @media (hover: hover) {
        border-color: #94a3b8;
      }
    }
  }
  .hover\\:border-\\[\\#875300\\]\\/40 {
    &:hover {
      @media (hover: hover) {
        border-color: color-mix(in oklab, #875300 40%, transparent);
      }
    }
  }
  .hover\\:border-\\[\\#875300\\]\\/50 {
    &:hover {
      @media (hover: hover) {
        border-color: color-mix(in oklab, #875300 50%, transparent);
      }
    }
  }
  .hover\\:border-\\[\\#cbd5e1\\] {
    &:hover {
      @media (hover: hover) {
        border-color: #cbd5e1;
      }
    }
  }
  .hover\\:border-\\[\\#d1d5db\\] {
    &:hover {
      @media (hover: hover) {
        border-color: #d1d5db;
      }
    }
  }
  .hover\\:border-\\[\\#f97316\\] {
    &:hover {
      @media (hover: hover) {
        border-color: #f97316;
      }
    }
  }
  .hover\\:border-\\[\\#fde4c4\\] {
    &:hover {
      @media (hover: hover) {
        border-color: #fde4c4;
      }
    }
  }
  .hover\\:border-amber-200 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-amber-200);
      }
    }
  }
  .hover\\:border-blue-200 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-blue-200);
      }
    }
  }
  .hover\\:border-blue-300 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-blue-300);
      }
    }
  }
  .hover\\:border-current {
    &:hover {
      @media (hover: hover) {
        border-color: currentcolor;
      }
    }
  }
  .hover\\:border-primary {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary);
      }
    }
  }
  .hover\\:border-primary\\/30 {
    &:hover {
      @media (hover: hover) {
        border-color: color-mix(in srgb, #f19500 30%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-primary) 30%, transparent);
        }
      }
    }
  }
  .hover\\:border-primary\\/40 {
    &:hover {
      @media (hover: hover) {
        border-color: color-mix(in srgb, #f19500 40%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-primary) 40%, transparent);
        }
      }
    }
  }
  .hover\\:border-secondary\\/30 {
    &:hover {
      @media (hover: hover) {
        border-color: color-mix(in srgb, #009dff 30%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-secondary) 30%, transparent);
        }
      }
    }
  }
  .hover\\:border-secondary\\/40 {
    &:hover {
      @media (hover: hover) {
        border-color: color-mix(in srgb, #009dff 40%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-secondary) 40%, transparent);
        }
      }
    }
  }
  .hover\\:border-white\\/50 {
    &:hover {
      @media (hover: hover) {
        border-color: color-mix(in srgb, #fff 50%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-white) 50%, transparent);
        }
      }
    }
  }
  .hover\\:bg-\\[\\#064a7a\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #064a7a;
      }
    }
  }
  .hover\\:bg-\\[\\#0088e6\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #0088e6;
      }
    }
  }
  .hover\\:bg-\\[\\#875300\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #875300;
      }
    }
  }
  .hover\\:bg-\\[\\#e07f00\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #e07f00;
      }
    }
  }
  .hover\\:bg-\\[\\#e08600\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #e08600;
      }
    }
  }
  .hover\\:bg-\\[\\#e08800\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #e08800;
      }
    }
  }
  .hover\\:bg-\\[\\#ea580c\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #ea580c;
      }
    }
  }
  .hover\\:bg-\\[\\#f1f5f9\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #f1f5f9;
      }
    }
  }
  .hover\\:bg-\\[\\#f3f4f6\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #f3f4f6;
      }
    }
  }
  .hover\\:bg-\\[\\#f5f5f7\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #f5f5f7;
      }
    }
  }
  .hover\\:bg-\\[\\#f8fafc\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #f8fafc;
      }
    }
  }
  .hover\\:bg-\\[\\#f9fafb\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #f9fafb;
      }
    }
  }
  .hover\\:bg-\\[\\#fafafa\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #fafafa;
      }
    }
  }
  .hover\\:bg-\\[\\#fee2e2\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #fee2e2;
      }
    }
  }
  .hover\\:bg-\\[\\#fef2f2\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #fef2f2;
      }
    }
  }
  .hover\\:bg-\\[\\#fef3c7\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #fef3c7;
      }
    }
  }
  .hover\\:bg-\\[\\#fff3dc\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #fff3dc;
      }
    }
  }
  .hover\\:bg-\\[\\#fff7ed\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #fff7ed;
      }
    }
  }
  .hover\\:bg-\\[\\#fff9ee\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #fff9ee;
      }
    }
  }
  .hover\\:bg-\\[rgba\\(241\\,149\\,0\\,0\\.16\\)\\] {
    &:hover {
      @media (hover: hover) {
        background-color: rgba(241,149,0,0.16);
      }
    }
  }
  .hover\\:bg-primary-hover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-hover);
      }
    }
  }
  .hover\\:bg-primary-soft {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-soft);
      }
    }
  }
  .hover\\:bg-primary-soft\\/60 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff9ee 60%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-primary-soft) 60%, transparent);
        }
      }
    }
  }
  .hover\\:bg-secondary-soft {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-secondary-soft);
      }
    }
  }
  .hover\\:bg-secondary-soft\\/30 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #eff7ff 30%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-secondary-soft) 30%, transparent);
        }
      }
    }
  }
  .hover\\:bg-secondary-soft\\/40 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #eff7ff 40%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-secondary-soft) 40%, transparent);
        }
      }
    }
  }
  .hover\\:bg-secondary-soft\\/80 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #eff7ff 80%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-secondary-soft) 80%, transparent);
        }
      }
    }
  }
  .hover\\:bg-slate-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-slate-50);
      }
    }
  }
  .hover\\:bg-slate-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-slate-100);
      }
    }
  }
  .hover\\:bg-white {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-white);
      }
    }
  }
  .hover\\:bg-white\\/15 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 15%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 15%, transparent);
        }
      }
    }
  }
  .hover\\:bg-white\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 20%, transparent);
        }
      }
    }
  }
  .hover\\:bg-white\\/60 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 60%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 60%, transparent);
        }
      }
    }
  }
  .hover\\:bg-white\\/70 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 70%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 70%, transparent);
        }
      }
    }
  }
  .hover\\:bg-white\\/80 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 80%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 80%, transparent);
        }
      }
    }
  }
  .hover\\:text-\\[\\#181c23\\] {
    &:hover {
      @media (hover: hover) {
        color: #181c23;
      }
    }
  }
  .hover\\:text-\\[\\#191b23\\] {
    &:hover {
      @media (hover: hover) {
        color: #191b23;
      }
    }
  }
  .hover\\:text-\\[\\#191c1e\\] {
    &:hover {
      @media (hover: hover) {
        color: #191c1e;
      }
    }
  }
  .hover\\:text-\\[\\#64748b\\] {
    &:hover {
      @media (hover: hover) {
        color: #64748b;
      }
    }
  }
  .hover\\:text-\\[\\#091426\\] {
    &:hover {
      @media (hover: hover) {
        color: #091426;
      }
    }
  }
  .hover\\:text-\\[\\#111827\\] {
    &:hover {
      @media (hover: hover) {
        color: #111827;
      }
    }
  }
  .hover\\:text-\\[\\#172033\\] {
    &:hover {
      @media (hover: hover) {
        color: #172033;
      }
    }
  }
  .hover\\:text-\\[\\#374151\\] {
    &:hover {
      @media (hover: hover) {
        color: #374151;
      }
    }
  }
  .hover\\:text-\\[\\#ef4444\\] {
    &:hover {
      @media (hover: hover) {
        color: #ef4444;
      }
    }
  }
  .hover\\:text-primary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary);
      }
    }
  }
  .hover\\:text-red-400 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-red-400);
      }
    }
  }
  .hover\\:text-secondary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-secondary);
      }
    }
  }
  .hover\\:text-slate-600 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-slate-600);
      }
    }
  }
  .hover\\:text-slate-800 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-slate-800);
      }
    }
  }
  .hover\\:text-text-primary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-text-primary);
      }
    }
  }
  .hover\\:text-white {
    &:hover {
      @media (hover: hover) {
        color: var(--color-white);
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .hover\\:opacity-90 {
    &:hover {
      @media (hover: hover) {
        opacity: 90%;
      }
    }
  }
  .hover\\:opacity-100 {
    &:hover {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .hover\\:shadow-\\[0_4px_12px_rgba\\(15\\,23\\,42\\,0\\.06\\)\\] {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 4px 12px var(--tw-shadow-color, rgba(15,23,42,0.06));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-\\[0px_8px_24px_rgba\\(15\\,23\\,42\\,0\\.08\\)\\] {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0px 8px 24px var(--tw-shadow-color, rgba(15,23,42,0.08));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-\\[0px_8px_24px_rgba\\(135\\,83\\,0\\,0\\.3\\)\\] {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0px 8px 24px var(--tw-shadow-color, rgba(135,83,0,0.3));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-md {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-sm {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .focus\\:border-\\[\\#006BB6\\] {
    &:focus {
      border-color: #006BB6;
    }
  }
  .focus\\:border-\\[\\#875300\\] {
    &:focus {
      border-color: #875300;
    }
  }
  .focus\\:border-\\[\\#f28a00\\] {
    &:focus {
      border-color: #f28a00;
    }
  }
  .focus\\:border-\\[\\#f04438\\] {
    &:focus {
      border-color: #f04438;
    }
  }
  .focus\\:border-\\[\\#f19500\\] {
    &:focus {
      border-color: #f19500;
    }
  }
  .focus\\:border-blue-400 {
    &:focus {
      border-color: var(--color-blue-400);
    }
  }
  .focus\\:border-indigo-400 {
    &:focus {
      border-color: var(--color-indigo-400);
    }
  }
  .focus\\:border-primary {
    &:focus {
      border-color: var(--color-primary);
    }
  }
  .focus\\:border-secondary {
    &:focus {
      border-color: var(--color-secondary);
    }
  }
  .focus\\:ring-2 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-\\[\\#006BB6\\]\\/25 {
    &:focus {
      --tw-ring-color: color-mix(in oklab, #006BB6 25%, transparent);
    }
  }
  .focus\\:ring-\\[\\#875300\\]\\/20 {
    &:focus {
      --tw-ring-color: color-mix(in oklab, #875300 20%, transparent);
    }
  }
  .focus\\:ring-primary\\/30 {
    &:focus {
      --tw-ring-color: color-mix(in srgb, #f19500 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-primary) 30%, transparent);
      }
    }
  }
  .focus\\:ring-secondary\\/25 {
    &:focus {
      --tw-ring-color: color-mix(in srgb, #009dff 25%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-secondary) 25%, transparent);
      }
    }
  }
  .focus\\:ring-secondary\\/30 {
    &:focus {
      --tw-ring-color: color-mix(in srgb, #009dff 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-secondary) 30%, transparent);
      }
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .focus-visible\\:bg-secondary-soft {
    &:focus-visible {
      background-color: var(--color-secondary-soft);
    }
  }
  .focus-visible\\:text-secondary {
    &:focus-visible {
      color: var(--color-secondary);
    }
  }
  .focus-visible\\:shadow-\\[0px_8px_24px_rgba\\(241\\,149\\,0\\,0\\.3\\)\\] {
    &:focus-visible {
      --tw-shadow: 0px 8px 24px var(--tw-shadow-color, rgba(241,149,0,0.3));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-1 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-2 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-\\[\\#875300\\] {
    &:focus-visible {
      --tw-ring-color: #875300;
    }
  }
  .focus-visible\\:ring-primary {
    &:focus-visible {
      --tw-ring-color: var(--color-primary);
    }
  }
  .focus-visible\\:ring-primary\\/30 {
    &:focus-visible {
      --tw-ring-color: color-mix(in srgb, #f19500 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-primary) 30%, transparent);
      }
    }
  }
  .focus-visible\\:ring-primary\\/40 {
    &:focus-visible {
      --tw-ring-color: color-mix(in srgb, #f19500 40%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-primary) 40%, transparent);
      }
    }
  }
  .focus-visible\\:ring-secondary\\/25 {
    &:focus-visible {
      --tw-ring-color: color-mix(in srgb, #009dff 25%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-secondary) 25%, transparent);
      }
    }
  }
  .focus-visible\\:ring-secondary\\/30 {
    &:focus-visible {
      --tw-ring-color: color-mix(in srgb, #009dff 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-secondary) 30%, transparent);
      }
    }
  }
  .focus-visible\\:ring-offset-2 {
    &:focus-visible {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus-visible\\:outline {
    &:focus-visible {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
    }
  }
  .focus-visible\\:outline-2 {
    &:focus-visible {
      outline-style: var(--tw-outline-style);
      outline-width: 2px;
    }
  }
  .focus-visible\\:outline-offset-2 {
    &:focus-visible {
      outline-offset: 2px;
    }
  }
  .focus-visible\\:outline-\\[\\#f19500\\] {
    &:focus-visible {
      outline-color: #f19500;
    }
  }
  .focus-visible\\:outline-none {
    &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .focus-visible\\:ring-inset {
    &:focus-visible {
      --tw-ring-inset: inset;
    }
  }
  .active\\:cursor-grabbing {
    &:active {
      cursor: grabbing;
    }
  }
  .active\\:bg-primary-active {
    &:active {
      background-color: var(--color-primary-active);
    }
  }
  .active\\:shadow-\\[0px_8px_24px_rgba\\(72\\,44\\,0\\,0\\.3\\)\\] {
    &:active {
      --tw-shadow: 0px 8px 24px var(--tw-shadow-color, rgba(72,44,0,0.3));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .disabled\\:cursor-not-allowed {
    &:disabled {
      cursor: not-allowed;
    }
  }
  .disabled\\:cursor-wait {
    &:disabled {
      cursor: wait;
    }
  }
  .disabled\\:border-\\[\\#d5dee8\\] {
    &:disabled {
      border-color: #d5dee8;
    }
  }
  .disabled\\:bg-\\[\\#c7c7c7\\] {
    &:disabled {
      background-color: #c7c7c7;
    }
  }
  .disabled\\:bg-\\[\\#f1f5f9\\] {
    &:disabled {
      background-color: #f1f5f9;
    }
  }
  .disabled\\:bg-\\[\\#f3f4f6\\] {
    &:disabled {
      background-color: #f3f4f6;
    }
  }
  .disabled\\:bg-\\[\\#f8c98e\\] {
    &:disabled {
      background-color: #f8c98e;
    }
  }
  .disabled\\:bg-\\[\\#f8fafc\\] {
    &:disabled {
      background-color: #f8fafc;
    }
  }
  .disabled\\:bg-\\[\\#fdba74\\] {
    &:disabled {
      background-color: #fdba74;
    }
  }
  .disabled\\:bg-primary-disabled {
    &:disabled {
      background-color: var(--color-primary-disabled);
    }
  }
  .disabled\\:text-\\[\\#7b8da3\\] {
    &:disabled {
      color: #7b8da3;
    }
  }
  .disabled\\:text-\\[\\#94a3b8\\] {
    &:disabled {
      color: #94a3b8;
    }
  }
  .disabled\\:text-\\[\\#949494\\] {
    &:disabled {
      color: #949494;
    }
  }
  .disabled\\:text-white {
    &:disabled {
      color: var(--color-white);
    }
  }
  .disabled\\:accent-\\[\\#c5ceda\\] {
    &:disabled {
      accent-color: #c5ceda;
    }
  }
  .disabled\\:opacity-20 {
    &:disabled {
      opacity: 20%;
    }
  }
  .disabled\\:opacity-30 {
    &:disabled {
      opacity: 30%;
    }
  }
  .disabled\\:opacity-40 {
    &:disabled {
      opacity: 40%;
    }
  }
  .disabled\\:opacity-50 {
    &:disabled {
      opacity: 50%;
    }
  }
  .disabled\\:opacity-60 {
    &:disabled {
      opacity: 60%;
    }
  }
  .disabled\\:opacity-70 {
    &:disabled {
      opacity: 70%;
    }
  }
  .disabled\\:opacity-80 {
    &:disabled {
      opacity: 80%;
    }
  }
  .disabled\\:opacity-100 {
    &:disabled {
      opacity: 100%;
    }
  }
  .disabled\\:shadow-none {
    &:disabled {
      --tw-shadow: 0 0 #0000;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .sm\\:inset-x-auto {
    @media (width >= 40rem) {
      inset-inline: auto;
    }
  }
  .sm\\:right-auto {
    @media (width >= 40rem) {
      right: auto;
    }
  }
  .sm\\:left-4 {
    @media (width >= 40rem) {
      left: var(--spacing-4);
    }
  }
  .sm\\:col-span-2 {
    @media (width >= 40rem) {
      grid-column: span 2 / span 2;
    }
  }
  .sm\\:mx-10 {
    @media (width >= 40rem) {
      margin-inline: var(--spacing-10);
    }
  }
  .sm\\:block {
    @media (width >= 40rem) {
      display: block;
    }
  }
  .sm\\:inline-flex {
    @media (width >= 40rem) {
      display: inline-flex;
    }
  }
  .sm\\:size-8 {
    @media (width >= 40rem) {
      width: var(--spacing-8);
      height: var(--spacing-8);
    }
  }
  .sm\\:h-8 {
    @media (width >= 40rem) {
      height: var(--spacing-8);
    }
  }
  .sm\\:h-10 {
    @media (width >= 40rem) {
      height: var(--spacing-10);
    }
  }
  .sm\\:h-\\[280px\\] {
    @media (width >= 40rem) {
      height: 280px;
    }
  }
  .sm\\:max-h-\\[280px\\] {
    @media (width >= 40rem) {
      max-height: 280px;
    }
  }
  .sm\\:min-h-\\[220px\\] {
    @media (width >= 40rem) {
      min-height: 220px;
    }
  }
  .sm\\:w-\\[224px\\] {
    @media (width >= 40rem) {
      width: 224px;
    }
  }
  .sm\\:w-auto {
    @media (width >= 40rem) {
      width: auto;
    }
  }
  .sm\\:max-w-\\[56\\%\\] {
    @media (width >= 40rem) {
      max-width: 56%;
    }
  }
  .sm\\:max-w-\\[260px\\] {
    @media (width >= 40rem) {
      max-width: 260px;
    }
  }
  .sm\\:max-w-\\[400px\\] {
    @media (width >= 40rem) {
      max-width: 400px;
    }
  }
  .sm\\:min-w-\\[104px\\] {
    @media (width >= 40rem) {
      min-width: 104px;
    }
  }
  .sm\\:flex-1 {
    @media (width >= 40rem) {
      flex: 1;
    }
  }
  .sm\\:shrink-0 {
    @media (width >= 40rem) {
      flex-shrink: 0;
    }
  }
  .sm\\:grid-cols-1 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
  .sm\\:grid-cols-2 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .sm\\:grid-cols-3 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .sm\\:grid-cols-\\[auto_minmax\\(0\\,1fr\\)\\] {
    @media (width >= 40rem) {
      grid-template-columns: auto minmax(0,1fr);
    }
  }
  .sm\\:flex-row {
    @media (width >= 40rem) {
      flex-direction: row;
    }
  }
  .sm\\:flex-wrap {
    @media (width >= 40rem) {
      flex-wrap: wrap;
    }
  }
  .sm\\:items-center {
    @media (width >= 40rem) {
      align-items: center;
    }
  }
  .sm\\:items-end {
    @media (width >= 40rem) {
      align-items: flex-end;
    }
  }
  .sm\\:items-start {
    @media (width >= 40rem) {
      align-items: flex-start;
    }
  }
  .sm\\:items-stretch {
    @media (width >= 40rem) {
      align-items: stretch;
    }
  }
  .sm\\:justify-between {
    @media (width >= 40rem) {
      justify-content: space-between;
    }
  }
  .sm\\:justify-end {
    @media (width >= 40rem) {
      justify-content: flex-end;
    }
  }
  .sm\\:gap-3 {
    @media (width >= 40rem) {
      gap: var(--spacing-3);
    }
  }
  .sm\\:gap-4 {
    @media (width >= 40rem) {
      gap: var(--spacing-4);
    }
  }
  .sm\\:gap-section-lg {
    @media (width >= 40rem) {
      gap: var(--spacing-section-lg);
    }
  }
  .sm\\:border-r {
    @media (width >= 40rem) {
      border-right-style: var(--tw-border-style);
      border-right-width: 1px;
    }
  }
  .sm\\:border-r-0 {
    @media (width >= 40rem) {
      border-right-style: var(--tw-border-style);
      border-right-width: 0px;
    }
  }
  .sm\\:border-b {
    @media (width >= 40rem) {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 1px;
    }
  }
  .sm\\:border-b-0 {
    @media (width >= 40rem) {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 0px;
    }
  }
  .sm\\:p-5 {
    @media (width >= 40rem) {
      padding: var(--spacing-5);
    }
  }
  .sm\\:p-6 {
    @media (width >= 40rem) {
      padding: var(--spacing-6);
    }
  }
  .sm\\:p-8 {
    @media (width >= 40rem) {
      padding: var(--spacing-8);
    }
  }
  .sm\\:p-12 {
    @media (width >= 40rem) {
      padding: var(--spacing-12);
    }
  }
  .sm\\:px-0 {
    @media (width >= 40rem) {
      padding-inline: var(--spacing-0);
    }
  }
  .sm\\:px-4 {
    @media (width >= 40rem) {
      padding-inline: var(--spacing-4);
    }
  }
  .sm\\:px-5 {
    @media (width >= 40rem) {
      padding-inline: var(--spacing-5);
    }
  }
  .sm\\:px-6 {
    @media (width >= 40rem) {
      padding-inline: var(--spacing-6);
    }
  }
  .sm\\:px-8 {
    @media (width >= 40rem) {
      padding-inline: var(--spacing-8);
    }
  }
  .sm\\:px-10 {
    @media (width >= 40rem) {
      padding-inline: var(--spacing-10);
    }
  }
  .sm\\:px-12 {
    @media (width >= 40rem) {
      padding-inline: var(--spacing-12);
    }
  }
  .sm\\:py-3 {
    @media (width >= 40rem) {
      padding-block: var(--spacing-3);
    }
  }
  .sm\\:py-4 {
    @media (width >= 40rem) {
      padding-block: var(--spacing-4);
    }
  }
  .sm\\:py-5 {
    @media (width >= 40rem) {
      padding-block: var(--spacing-5);
    }
  }
  .sm\\:py-6 {
    @media (width >= 40rem) {
      padding-block: var(--spacing-6);
    }
  }
  .sm\\:py-8 {
    @media (width >= 40rem) {
      padding-block: var(--spacing-8);
    }
  }
  .sm\\:py-10 {
    @media (width >= 40rem) {
      padding-block: var(--spacing-10);
    }
  }
  .sm\\:py-12 {
    @media (width >= 40rem) {
      padding-block: var(--spacing-12);
    }
  }
  .sm\\:pt-10 {
    @media (width >= 40rem) {
      padding-top: var(--spacing-10);
    }
  }
  .sm\\:pb-action-bar-lg {
    @media (width >= 40rem) {
      padding-bottom: var(--spacing-action-bar-lg);
    }
  }
  .sm\\:text-left {
    @media (width >= 40rem) {
      text-align: left;
    }
  }
  .sm\\:text-2xl {
    @media (width >= 40rem) {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
  }
  .sm\\:text-4xl {
    @media (width >= 40rem) {
      font-size: var(--text-4xl);
      line-height: var(--tw-leading, var(--text-4xl--line-height));
    }
  }
  .sm\\:text-base {
    @media (width >= 40rem) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
  }
  .sm\\:text-xl {
    @media (width >= 40rem) {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  .sm\\:text-\\[11px\\] {
    @media (width >= 40rem) {
      font-size: 11px;
    }
  }
  .sm\\:text-\\[28px\\] {
    @media (width >= 40rem) {
      font-size: 28px;
    }
  }
  .sm\\:text-\\[32px\\] {
    @media (width >= 40rem) {
      font-size: 32px;
    }
  }
  .sm\\:text-\\[34px\\] {
    @media (width >= 40rem) {
      font-size: 34px;
    }
  }
  .sm\\:text-\\[36px\\] {
    @media (width >= 40rem) {
      font-size: 36px;
    }
  }
  .sm\\:leading-7 {
    @media (width >= 40rem) {
      --tw-leading: var(--spacing-7);
      line-height: var(--spacing-7);
    }
  }
  .sm\\:leading-8 {
    @media (width >= 40rem) {
      --tw-leading: var(--spacing-8);
      line-height: var(--spacing-8);
    }
  }
  .sm\\:leading-\\[1\\.2\\] {
    @media (width >= 40rem) {
      --tw-leading: 1.2;
      line-height: 1.2;
    }
  }
  .md\\:flex {
    @media (width >= 48rem) {
      display: flex;
    }
  }
  .md\\:grid {
    @media (width >= 48rem) {
      display: grid;
    }
  }
  .md\\:hidden {
    @media (width >= 48rem) {
      display: none;
    }
  }
  .md\\:table-cell {
    @media (width >= 48rem) {
      display: table-cell;
    }
  }
  .md\\:h-\\[96px\\] {
    @media (width >= 48rem) {
      height: 96px;
    }
  }
  .md\\:w-\\[96px\\] {
    @media (width >= 48rem) {
      width: 96px;
    }
  }
  .md\\:grid-cols-2 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-3 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-5 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
  .md\\:border-l {
    @media (width >= 48rem) {
      border-left-style: var(--tw-border-style);
      border-left-width: 1px;
    }
  }
  .md\\:border-\\[\\#e5e7eb\\] {
    @media (width >= 48rem) {
      border-color: #e5e7eb;
    }
  }
  .md\\:p-10 {
    @media (width >= 48rem) {
      padding: var(--spacing-10);
    }
  }
  .md\\:pl-4 {
    @media (width >= 48rem) {
      padding-left: var(--spacing-4);
    }
  }
  .lg\\:relative {
    @media (width >= 64rem) {
      position: relative;
    }
  }
  .lg\\:sticky {
    @media (width >= 64rem) {
      position: sticky;
    }
  }
  .lg\\:top-0 {
    @media (width >= 64rem) {
      top: var(--spacing-0);
    }
  }
  .lg\\:z-auto {
    @media (width >= 64rem) {
      z-index: auto;
    }
  }
  .lg\\:block {
    @media (width >= 64rem) {
      display: block;
    }
  }
  .lg\\:flex {
    @media (width >= 64rem) {
      display: flex;
    }
  }
  .lg\\:hidden {
    @media (width >= 64rem) {
      display: none;
    }
  }
  .lg\\:h-\\[131px\\] {
    @media (width >= 64rem) {
      height: 131px;
    }
  }
  .lg\\:h-dvh {
    @media (width >= 64rem) {
      height: 100dvh;
    }
  }
  .lg\\:h-screen {
    @media (width >= 64rem) {
      height: 100vh;
    }
  }
  .lg\\:w-1\\/2 {
    @media (width >= 64rem) {
      width: calc(1 / 2 * 100%);
    }
  }
  .lg\\:w-\\[131px\\] {
    @media (width >= 64rem) {
      width: 131px;
    }
  }
  .lg\\:w-\\[var\\(--sidebar-width\\)\\] {
    @media (width >= 64rem) {
      width: var(--sidebar-width);
    }
  }
  .lg\\:shrink-0 {
    @media (width >= 64rem) {
      flex-shrink: 0;
    }
  }
  .lg\\:translate-x-0 {
    @media (width >= 64rem) {
      --tw-translate-x: var(--spacing-0);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .lg\\:grid-cols-2 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-3 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-4 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-5 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-6 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(6, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-\\[1\\.4fr_0\\.8fr_0\\.8fr\\] {
    @media (width >= 64rem) {
      grid-template-columns: 1.4fr 0.8fr 0.8fr;
    }
  }
  .lg\\:grid-cols-\\[1fr_280px\\] {
    @media (width >= 64rem) {
      grid-template-columns: 1fr 280px;
    }
  }
  .lg\\:grid-cols-\\[1fr_320px\\] {
    @media (width >= 64rem) {
      grid-template-columns: 1fr 320px;
    }
  }
  .lg\\:grid-cols-\\[minmax\\(0\\,1\\.4fr\\)_minmax\\(0\\,0\\.8fr\\)_minmax\\(0\\,0\\.8fr\\)\\] {
    @media (width >= 64rem) {
      grid-template-columns: minmax(0,1.4fr) minmax(0,0.8fr) minmax(0,0.8fr);
    }
  }
  .lg\\:grid-cols-\\[minmax\\(0\\,1fr\\)_320px\\] {
    @media (width >= 64rem) {
      grid-template-columns: minmax(0,1fr) 320px;
    }
  }
  .lg\\:grid-cols-\\[minmax\\(0\\,1fr\\)_minmax\\(260px\\,360px\\)\\] {
    @media (width >= 64rem) {
      grid-template-columns: minmax(0,1fr) minmax(260px,360px);
    }
  }
  .lg\\:flex-row {
    @media (width >= 64rem) {
      flex-direction: row;
    }
  }
  .lg\\:items-center {
    @media (width >= 64rem) {
      align-items: center;
    }
  }
  .lg\\:items-end {
    @media (width >= 64rem) {
      align-items: flex-end;
    }
  }
  .lg\\:justify-between {
    @media (width >= 64rem) {
      justify-content: space-between;
    }
  }
  .lg\\:justify-start {
    @media (width >= 64rem) {
      justify-content: flex-start;
    }
  }
  .lg\\:gap-4 {
    @media (width >= 64rem) {
      gap: var(--spacing-4);
    }
  }
  .lg\\:gap-dashboard-stack {
    @media (width >= 64rem) {
      gap: var(--spacing-dashboard-stack);
    }
  }
  .lg\\:px-10 {
    @media (width >= 64rem) {
      padding-inline: var(--spacing-10);
    }
  }
  .lg\\:px-16 {
    @media (width >= 64rem) {
      padding-inline: calc(var(--spacing) * 16);
    }
  }
  .lg\\:px-page-x-lg {
    @media (width >= 64rem) {
      padding-inline: var(--spacing-page-x-lg);
    }
  }
  .lg\\:px-toolbar-x-lg {
    @media (width >= 64rem) {
      padding-inline: var(--spacing-toolbar-x-lg);
    }
  }
  .lg\\:py-page-y-lg {
    @media (width >= 64rem) {
      padding-block: var(--spacing-page-y-lg);
    }
  }
  .lg\\:text-\\[32px\\] {
    @media (width >= 64rem) {
      font-size: 32px;
    }
  }
  .lg\\:text-\\[40px\\] {
    @media (width >= 64rem) {
      font-size: 40px;
    }
  }
  .lg\\:leading-\\[50px\\] {
    @media (width >= 64rem) {
      --tw-leading: 50px;
      line-height: 50px;
    }
  }
  .xl\\:col-span-1 {
    @media (width >= 80rem) {
      grid-column: span 1 / span 1;
    }
  }
  .xl\\:max-h-none {
    @media (width >= 80rem) {
      max-height: none;
    }
  }
  .xl\\:grid-cols-1 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
  .xl\\:grid-cols-2 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .xl\\:grid-cols-3 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .xl\\:grid-cols-4 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .xl\\:grid-cols-5 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
  .xl\\:grid-cols-\\[minmax\\(0\\,1\\.4fr\\)_minmax\\(0\\,1fr\\)_repeat\\(3\\,minmax\\(0\\,5rem\\)\\)_auto\\] {
    @media (width >= 80rem) {
      grid-template-columns: minmax(0,1.4fr) minmax(0,1fr) repeat(3,minmax(0,5rem)) auto;
    }
  }
  .xl\\:grid-cols-\\[minmax\\(0\\,1fr\\)_minmax\\(280px\\,436px\\)\\] {
    @media (width >= 80rem) {
      grid-template-columns: minmax(0,1fr) minmax(280px,436px);
    }
  }
  .xl\\:grid-cols-\\[minmax\\(0\\,597px\\)_minmax\\(320px\\,1fr\\)\\] {
    @media (width >= 80rem) {
      grid-template-columns: minmax(0,597px) minmax(320px,1fr);
    }
  }
  .xl\\:grid-cols-\\[minmax\\(0\\,640px\\)_minmax\\(0\\,436px\\)\\] {
    @media (width >= 80rem) {
      grid-template-columns: minmax(0,640px) minmax(0,436px);
    }
  }
  .xl\\:items-end {
    @media (width >= 80rem) {
      align-items: flex-end;
    }
  }
  .disabled\\:\\[\\&_img\\]\\:\\[filter\\:brightness\\(0\\)_invert\\(58\\%\\)\\] {
    &:disabled {
      & img {
        filter: brightness(0) invert(58%);
      }
    }
  }
  .disabled\\:\\[\\&_span\\]\\:text-\\[\\#949494\\] {
    &:disabled {
      & span {
        color: #949494;
      }
    }
  }
}
html {
  color-scheme: light;
  color-scheme: only light;
}
@keyframes workspace-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes workspace-fade-up-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes workspace-fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes workspace-skeleton-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}
@keyframes crafting-ring {
  0% {
    stroke-dashoffset: 360;
    transform: rotate(0deg);
  }
  50% {
    stroke-dashoffset: 120;
  }
  100% {
    stroke-dashoffset: 360;
    transform: rotate(360deg);
  }
}
body {
  margin: 0;
  overflow-x: hidden;
  color-scheme: light;
  color-scheme: only light;
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  background: var(--color-page-bg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media (min-width: 1024px) {
  .tema-sticky-sidebar-offset {
    left: var(--sidebar-width, 264px);
  }
}
@media (min-width: 1024px) {
  .tema-page-padding {
    padding-inline: var(--spacing-page-x-lg);
    padding-block: var(--spacing-page-y-lg);
  }
}
@media (min-width: 640px) {
  .tema-section-stack {
    gap: var(--spacing-section-lg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .workspace-enter,
  .workspace-overlay-enter,
  .workspace-overlay-exit,
  .workspace-skeleton-pulse,
  .animate-pulse,
  .animate-spin,
  .animate-\\[crafting-ring_1\\.8s_ease-in-out_infinite\\] {
    animation: none !important;
  }
  .workspace-enter,
  .workspace-overlay-enter,
  .workspace-overlay-exit {
    opacity: 1;
    transform: none;
  }
}
.tema-module-root[data-teacher-theme="high-contrast"] {
  --color-page-bg: #ffffff;
  --color-text-primary: #111111;
  --color-text-secondary: #111111;
  --color-text-muted: #374151;
  background-color: #ffffff;
}
.tema-module-root[data-teacher-theme="high-contrast"] .bg-white,
.tema-module-root[data-teacher-theme="high-contrast"] .bg-page-bg {
  background-color: #ffffff !important;
}
.tema-module-root[data-teacher-theme="high-contrast"] .text-text-primary,
.tema-module-root[data-teacher-theme="high-contrast"] .text-text-secondary,
.tema-module-root[data-teacher-theme="high-contrast"] .text-text-muted {
  color: #111111 !important;
}
.tema-module-root[data-teacher-theme="high-contrast"] .bg-sidebar {
  background-color: #ffffff !important;
  color: #111111 !important;
  border-right: 1px solid #d1d5db;
}
.tema-module-root[data-teacher-theme="high-contrast"] .bg-sidebar .text-white,
.tema-module-root[data-teacher-theme="high-contrast"] .bg-sidebar .text-slate-300 {
  color: #111111 !important;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-divide-x-reverse: 0;
      --tw-border-style: solid;
      --tw-divide-y-reverse: 0;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}

`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./src/index.css"],"names":[],"mappings":"AAAA,iEAAA;AC86BE,iBAAmB;AA96BrB,yCAAyC;AAEzC;EACE;IC8DA,6CAA8C;ID1D5C,yEAAyE;ICkE3E,+CAAgD;ID7D9C,wCAAwC;IACxC,0CAA0C;IAC1C,0CAA0C;IAE1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAK1C,6CAA6C;IAW7C,2CAA2C;IAE3C,2CAA2C;IAK3C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IA2B5C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAsD7C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAE5C,4CAA4C;IAO5C,4CAA4C;IAC5C,4CAA4C;IAE5C,8CAA8C;IAS9C,8CAA8C;IAM9C,6CAA6C;IAO7C,8CAA8C;IAyC9C,2CAA2C;IAC3C,2CAA2C;IAI3C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAoG7C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAUlB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IAItB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,0BAA0B;IAY1B,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IAGxB,0BAA0B;IAE1B,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IAExB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;IAIxB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IAsCpB,sCAAsC;IACtC,2CAA2C;IAE3C,uCAAuC;IAEvC,+DAA+D;IAC/D,oCAAoC;IAoCpC,cAAc;IAId,gBAAgB;IAChB,gBAAgB;IAQhB,sBAAsB;IAEtB,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;ICtf3D,wBAAyB;IAGzB,wBAAyB;IACzB,wBAAyB;IACzB,8BAA+B;IAC/B,+BAAgC;IAChC,iCAAkC;IAClC,6BAA8B;IAC9B,0BAA2B;IAC3B,+BAAgC;IAChC,6BAA8B;IAC9B,+BAAgC;IAEhC,wBAAyB;IACzB,0CAA2C;IAG3C,cAAe;IACf,oBAAqB;IACrB,mBAAoB;IACpB,oBAAqB;IACrB,iBAAkB;IAClB,oBAAqB;IACrB,mBAAoB;IACpB,oBAAqB;IACrB,iBAAkB;IAClB,oBAAqB;IACrB,kBAAmB;IAGnB,0BAA2B;IAC3B,yBAA0B;IAC1B,uBAAwB;IACxB,sBAAuB;IACvB,wBAAyB;IACzB,yBAA0B;IAC1B,sBAAuB;IACvB,yBAA0B;IAE1B,yBAA0B;IAC1B,yBAA0B;IAC1B,0BAA2B;IAC3B,8BAA+B;IAC/B,iCAAkC;IAClC,0BAA2B;IAC3B,6BAA8B;IAC9B,uBAAwB;IACxB,wBAAyB;IACzB,iCAAkC;IAClC,iCAAkC;IAQlC,4CAA6C;IAE7C,qEAAsE;IACtE,iEAAkE;IAKlE,iCAAkC;IAClC,yCAA0C;IAC1C,wCAAyC;IACzC,gDAAiD;ED3ElC;AADJ;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;ICpsBA,aAAc;IACd,sBAAuB;IACvB,2BAA4B;EDksBT;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IC/vBA,qBAAsB;IACtB,qDAAsD;IAEtD;MACE,UAAW;MACX,WAAY;IACb;IAED;MACE,uBAAwB;IACzB;IAED;MACE,0CAA2C;MAC3C,qBAAsB;IACvB;IAED;MACE,0CAA2C;IAC5C;ED4uBkB;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,yBAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,yBAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,UAAmB;IAAnB,WAAmB;EAAA;EAAnB;IAAA,cAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,YAAmB;IAAnB,aAAmB;EAAA;EAAnB;IAAA,YAAmB;IAAnB,aAAmB;EAAA;EAAnB;IAAA,YAAmB;IAAnB,aAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;ICvuBA,qBAAsB;IACtB,oCAAqC;IAErC;MACE,UAAW;IACZ;IAED;MACE,uBAAwB;IACzB;IAED;MACE,yBAA0B;MAC1B,kBAAmB;IACpB;EDytBkB;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;ICjyBA,0FAA2F;EDiyBxE;EAAnB;IC7xBA,+FAAgG;ED6xB7E;EAAnB;ICzxBA,iFAAkF;EDyxB/D;EAAnB;ICrxBA,2DAA4D;EDqxBzC;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,2CAAmB;MAAnB,iEAAmB;MAAnB,yEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,2CAAmB;MAAnB,wCAAmB;MAAnB,wDAAmB;MAAnB,qEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,wIAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gEAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,gEAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;ICrtBA,oCAAqC;IACrC,mCAAoC;EDotBjB;EAAnB;IChtBA,qCAAsC;IACtC,oCAAqC;ED+sBlB;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,cAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,yBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,mDAAmB;IAAnB;MAAA,iEAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,mDAAmB;IAAnB;MAAA,mEAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0EAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,mEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,mEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,mEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,mEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,2EAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0EAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0EAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,2EAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0EAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,2EAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,8DAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,6DAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,6DAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,6FAAmB;IAAnB,4CAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,6FAAmB;IAAnB,4CAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,kKAAmB;IAAnB,4CAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,+FAAmB;IAAnB,4CAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,yUAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;MAAnB,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0DAAmB;QAAnB;UAAA,wEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0DAAmB;QAAnB;UAAA,wEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uDAAmB;QAAnB;UAAA,sEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8DAAmB;QAAnB;UAAA,iFAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8DAAmB;QAAnB;UAAA,mFAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8DAAmB;QAAnB;UAAA,mFAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8DAAmB;QAAnB;UAAA,mFAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mEAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qEAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oEAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6HAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0HAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;MAAnB;QAAA,2EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qEAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;MAAnB;QAAA,2EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;MAAnB;QAAA,2EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;MAAnB,4GAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mEAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,OAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;MAAnB,6DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;MAAnB,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;MAAnB,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;MAAnB,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;MAAnB,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;AADJ;AC16BjB;EACE,mBAAoB;EACpB,wBAAyB;AAC1B;AA2ED;EACE;IACE,UAAW;EACZ;EAED;IACE,UAAW;EACZ;AACF;AAED;EACE;IACE,UAAW;IACX,0BAA2B;EAC5B;EAED;IACE,UAAW;IACX,wBAAyB;EAC1B;AACF;AAED;EACE;IACE,UAAW;EACZ;EAED;IACE,UAAW;EACZ;AACF;AAED;EACE;;IAEE,UAAW;EACZ;EAED;IACE,aAAc;EACf;AACF;AAED;EACE;IACE,sBAAuB;IACvB,uBAAwB;EACzB;EAED;IACE,sBAAuB;EACxB;EAED;IACE,sBAAuB;IACvB,yBAA0B;EAC3B;AACF;AAkBD;EACE,SAAU;EACV,kBAAmB;EACnB,mBAAoB;EACpB,wBAAyB;EACzB,6BAA8B;EAC9B,gCAAiC;EACjC,gCAAiC;EACjC,mCAAoC;EACpC,kCAAmC;AACpC;AAED;EACE;IACE,iCAAkC;EACnC;AACF;AAsDD;EACE;IACE,wCAAyC;IACzC,uCAAwC;EACzC;AACF;AAQD;EACE;IACE,8BAA+B;EAChC;AACF;AAED;EACE;;;;;;;IAOE,0BAA2B;EAC5B;EAED;;;IAGE,UAAW;IACX,eAAgB;EACjB;AACF;AAGD;EACE,wBAAyB;EACzB,6BAA8B;EAC9B,+BAAgC;EAChC,2BAA4B;EAC5B,yBAA0B;AAC3B;AAED;;EAEE,oCAAqC;AACtC;AAED;;;EAGE,yBAA0B;AAC3B;AAED;EACE,oCAAqC;EACrC,yBAA0B;EAC1B,+BAAgC;AACjC;AAED;;EAEE,yBAA0B;AAC3B;ADyoBC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,iBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AA3ejB;EACE;IACE,yBAAyB;EADxB;AADW;AAchB;EACE;IACE,YAAY;EADV;AADW;AAMjB;EACE;IAEE,2BAA2B;IAC3B,qDAAqD;EAFlD;EAKL;IACE,eAAe;IACf,qDAAqD;EAFnD;AAPY;AAudpB;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,+BAAmB;MAAnB,yBAAmB;MAAnB,wBAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,qBAAmB;MAAnB,0BAAmB;MAAnB,4BAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,400&family=Hanken+Grotesk:ital,wght@0,400;0,500;0,600;0,700;1,500&family=Inter:wght@400;500;600&family=Plus+Jakarta+Sans:wght@600;700;800&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,800&display=swap\");\n@import \"tailwindcss\";\n\nhtml {\n  color-scheme: light;\n  color-scheme: only light;\n}\n\n@theme {\n  --color-sidebar: #eff7ff;\n  --color-sidebar-hover: rgba(255, 255, 255, 0.65);\n  --color-nav-active: #f19500;\n  --color-page-bg: #f8fafc;\n  --color-primary: #f19500;\n  --color-primary-hover: #875300;\n  --color-primary-active: #482c00;\n  --color-primary-disabled: #fff9ee;\n  --color-primary-soft: #fff9ee;\n  --color-secondary: #009dff;\n  --color-secondary-soft: #eff7ff;\n  --color-text-primary: #1d1b20;\n  --color-text-secondary: #494551;\n  --color-text-muted: #cbc4d2;\n  --color-preview: #4f378a;\n  --color-preview-bg: rgba(79, 55, 138, 0.1);\n\n  /* ── TEMA spacing scale (4px base) ───────────────────────────────────── */\n  --spacing-0: 0;\n  --spacing-1: 0.25rem; /* 4px */\n  --spacing-2: 0.5rem; /* 8px */\n  --spacing-3: 0.75rem; /* 12px */\n  --spacing-4: 1rem; /* 16px */\n  --spacing-5: 1.25rem; /* 20px */\n  --spacing-6: 1.5rem; /* 24px */\n  --spacing-7: 1.75rem; /* 28px */\n  --spacing-8: 2rem; /* 32px */\n  --spacing-10: 2.5rem; /* 40px */\n  --spacing-12: 3rem; /* 48px */\n\n  /* Semantic layout spacing */\n  --spacing-stack-sm: 0.5rem; /* 8px — tight inline stacks */\n  --spacing-inline: 0.75rem; /* 12px — toolbar / control groups */\n  --spacing-card-sm: 1rem; /* 16px — compact cards, panels */\n  --spacing-page-x: 1rem; /* 16px — mobile page horizontal inset */\n  --spacing-page-y: 1.5rem; /* 24px — mobile page vertical inset */\n  --spacing-section: 1.5rem; /* 24px — default section gap */\n  --spacing-card: 1.5rem; /* 24px — card padding */\n  --spacing-toolbar-x: 1rem; /* 16px */\n  --spacing-toolbar-y: 0.5rem; /* 8px */\n  --spacing-page-x-lg: 2rem; /* 32px — desktop page horizontal inset */\n  --spacing-page-y-lg: 2rem; /* 32px — desktop page vertical inset */\n  --spacing-section-lg: 2rem; /* 32px — desktop section gap */\n  --spacing-toolbar-x-lg: 1.5rem; /* 24px */\n  --spacing-dashboard-stack: 2.5rem; /* 40px — dashboard vertical rhythm */\n  --spacing-action-bar: 6rem; /* 96px — sticky action bar offset */\n  --spacing-action-bar-lg: 7rem; /* 112px — sticky action bar offset (sm+) */\n  --spacing-btn-x: 1.5rem; /* 24px — button horizontal padding */\n  --spacing-btn-y: 0.75rem; /* 12px — button vertical padding */\n  --spacing-content-max: 67.3125rem; /* 1077px — workspace content width */\n  --spacing-dashboard-max: 68.75rem; /* 1100px — dashboard content width */\n\n  /* Legacy aliases (prefer --spacing-btn-*) */\n  --spacing-button-padding-x: var(--spacing-btn-x);\n  --spacing-button-padding-y: var(--spacing-btn-y);\n  /* Figma: DM Sans for dashboard content */\n  --font-sans: \"DM Sans\", system-ui, sans-serif;\n  /* Figma: Inter for top bar, sidebar nav, unlock CTA */\n  --font-inter: \"Inter\", system-ui, sans-serif;\n  /* Auth and onboarding */\n  --font-jakarta: \"Plus Jakarta Sans\", \"DM Sans\", system-ui, sans-serif;\n  --font-hanken: \"Hanken Grotesk\", \"DM Sans\", system-ui, sans-serif;\n  --font-poppins: \"Poppins\", \"DM Sans\", system-ui, sans-serif;\n  /* Figma: Consolas for employee ID in header */\n  --font-mono: Consolas, \"Courier New\", monospace;\n  /* Workspace motion tokens */\n  --duration-workspace-enter: 220ms;\n  --duration-workspace-overlay-enter: 180ms;\n  --duration-workspace-overlay-exit: 160ms;\n  --ease-workspace: cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes workspace-fade-in {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes workspace-fade-up-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes workspace-fade-out {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes workspace-skeleton-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.55;\n  }\n}\n\n@keyframes crafting-ring {\n  0% {\n    stroke-dashoffset: 360;\n    transform: rotate(0deg);\n  }\n\n  50% {\n    stroke-dashoffset: 120;\n  }\n\n  100% {\n    stroke-dashoffset: 360;\n    transform: rotate(360deg);\n  }\n}\n\n@utility workspace-enter {\n  animation: workspace-fade-up-in var(--duration-workspace-enter) var(--ease-workspace) both;\n}\n\n@utility workspace-overlay-enter {\n  animation: workspace-fade-in var(--duration-workspace-overlay-enter) var(--ease-workspace) both;\n}\n\n@utility workspace-overlay-exit {\n  animation: workspace-fade-out var(--duration-workspace-overlay-exit) ease-in both;\n}\n\n@utility workspace-skeleton-pulse {\n  animation: workspace-skeleton-pulse 2s ease-in-out infinite;\n}\n\nbody {\n  margin: 0;\n  overflow-x: hidden;\n  color-scheme: light;\n  color-scheme: only light;\n  font-family: var(--font-sans);\n  color: var(--color-text-primary);\n  background: var(--color-page-bg);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n@media (min-width: 1024px) {\n  .tema-sticky-sidebar-offset {\n    left: var(--sidebar-width, 264px);\n  }\n}\n\n@utility scrollbar-slim {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(192, 198, 214, 0.6) transparent;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(192, 198, 214, 0.6);\n    border-radius: 9999px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(150, 158, 178, 0.8);\n  }\n}\n\n/* Figma filter dropdown panels (Curriculum / Grade / Subject cards) */\n@utility scrollbar-filter {\n  scrollbar-width: thin;\n  scrollbar-color: #e1e4e8 transparent;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #e1e4e8;\n    border-radius: 4px;\n  }\n}\n\n@utility tema-btn-padding {\n  padding-inline: var(--spacing-btn-x);\n  padding-block: var(--spacing-btn-y);\n}\n\n@utility tema-page-padding {\n  padding-inline: var(--spacing-page-x);\n  padding-block: var(--spacing-page-y);\n}\n\n@media (min-width: 1024px) {\n  .tema-page-padding {\n    padding-inline: var(--spacing-page-x-lg);\n    padding-block: var(--spacing-page-y-lg);\n  }\n}\n\n@utility tema-section-stack {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-section);\n}\n\n@media (min-width: 640px) {\n  .tema-section-stack {\n    gap: var(--spacing-section-lg);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .workspace-enter,\n  .workspace-overlay-enter,\n  .workspace-overlay-exit,\n  .workspace-skeleton-pulse,\n  .animate-pulse,\n  .animate-spin,\n  .animate-\\[crafting-ring_1\\.8s_ease-in-out_infinite\\] {\n    animation: none !important;\n  }\n\n  .workspace-enter,\n  .workspace-overlay-enter,\n  .workspace-overlay-exit {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n/* TutorCloud Font & Display Controls (Text Size / Contrast; TEMA is light-only) */\n.tema-module-root[data-teacher-theme=\"high-contrast\"] {\n  --color-page-bg: #ffffff;\n  --color-text-primary: #111111;\n  --color-text-secondary: #111111;\n  --color-text-muted: #374151;\n  background-color: #ffffff;\n}\n\n.tema-module-root[data-teacher-theme=\"high-contrast\"] .bg-white,\n.tema-module-root[data-teacher-theme=\"high-contrast\"] .bg-page-bg {\n  background-color: #ffffff !important;\n}\n\n.tema-module-root[data-teacher-theme=\"high-contrast\"] .text-text-primary,\n.tema-module-root[data-teacher-theme=\"high-contrast\"] .text-text-secondary,\n.tema-module-root[data-teacher-theme=\"high-contrast\"] .text-text-muted {\n  color: #111111 !important;\n}\n\n.tema-module-root[data-teacher-theme=\"high-contrast\"] .bg-sidebar {\n  background-color: #ffffff !important;\n  color: #111111 !important;\n  border-right: 1px solid #d1d5db;\n}\n\n.tema-module-root[data-teacher-theme=\"high-contrast\"] .bg-sidebar .text-white,\n.tema-module-root[data-teacher-theme=\"high-contrast\"] .bg-sidebar .text-slate-300 {\n  color: #111111 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
